export function SearchIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11" cy="11" r="6" stroke="#1E1D1C" />
      <path d="M20 20L17 17" stroke="#1E1D1C" stroke-linecap="round" />
    </svg>
  );
}

export function Heart() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.00001 8.77722C5.2068 8.10662 5.57722 7.47652 6.14527 6.91333C6.59251 6.4699 7.05668 6.17747 7.52241 6.00049M13.6007 4.14642C15.2743 3.08474 17.9773 2.08081 20.3115 4.4612C25.8525 10.1119 16.3502 21.0005 12 21.0005C7.64988 21.0005 -1.85249 10.1119 3.68853 4.4612C6.02272 2.08083 8.72564 3.08476 10.3993 4.14642C11.345 4.7463 12.655 4.7463 13.6007 4.14642Z"
        stroke="#1E1D1C"
        stroke-linecap="round"
      />
    </svg>
  );
}

export function Basket() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.19 17.7505H7.53999C6.54999 17.7505 5.59999 17.3305 4.92999 16.6005C4.25999 15.8705 3.92 14.8905 4 13.9005L4.83 3.94049C4.86 3.63049 4.74999 3.33049 4.53999 3.10049C4.32999 2.87049 4.04 2.75049 3.73 2.75049H2C1.59 2.75049 1.25 2.41049 1.25 2.00049C1.25 1.59049 1.59 1.25049 2 1.25049H3.74001C4.47001 1.25049 5.15999 1.56048 5.64999 2.09048C5.91999 2.39048 6.12 2.74049 6.23 3.13049H18.72C19.73 3.13049 20.66 3.53049 21.34 4.25049C22.01 4.98049 22.35 5.93049 22.27 6.94049L21.73 14.4405C21.62 16.2705 20.02 17.7505 18.19 17.7505ZM6.28 4.62048L5.5 14.0205C5.45 14.6005 5.64 15.1505 6.03 15.5805C6.42 16.0105 6.95999 16.2405 7.53999 16.2405H18.19C19.23 16.2405 20.17 15.3605 20.25 14.3205L20.79 6.8205C20.83 6.2305 20.64 5.6705 20.25 5.2605C19.86 4.8405 19.32 4.61047 18.73 4.61047H6.28V4.62048Z"
        fill="#292D32"
      />
      <path
        d="M16.25 22.7505C15.15 22.7505 14.25 21.8505 14.25 20.7505C14.25 19.6505 15.15 18.7505 16.25 18.7505C17.35 18.7505 18.25 19.6505 18.25 20.7505C18.25 21.8505 17.35 22.7505 16.25 22.7505ZM16.25 20.2505C15.97 20.2505 15.75 20.4705 15.75 20.7505C15.75 21.0305 15.97 21.2505 16.25 21.2505C16.53 21.2505 16.75 21.0305 16.75 20.7505C16.75 20.4705 16.53 20.2505 16.25 20.2505Z"
        fill="#292D32"
      />
      <path
        d="M8.25 22.7505C7.15 22.7505 6.25 21.8505 6.25 20.7505C6.25 19.6505 7.15 18.7505 8.25 18.7505C9.35 18.7505 10.25 19.6505 10.25 20.7505C10.25 21.8505 9.35 22.7505 8.25 22.7505ZM8.25 20.2505C7.97 20.2505 7.75 20.4705 7.75 20.7505C7.75 21.0305 7.97 21.2505 8.25 21.2505C8.53 21.2505 8.75 21.0305 8.75 20.7505C8.75 20.4705 8.53 20.2505 8.25 20.2505Z"
        fill="#292D32"
      />
      <path
        d="M21 8.75049H9C8.59 8.75049 8.25 8.41049 8.25 8.00049C8.25 7.59049 8.59 7.25049 9 7.25049H21C21.41 7.25049 21.75 7.59049 21.75 8.00049C21.75 8.41049 21.41 8.75049 21 8.75049Z"
        fill="#292D32"
      />
    </svg>
  );
}

export function MenuIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M5 7H19" stroke="#1E1D1C" stroke-linecap="round" />
      <path d="M5 12H19" stroke="#1E1D1C" stroke-linecap="round" />
      <path d="M5 17H19" stroke="#1E1D1C" stroke-linecap="round" />
    </svg>
  );
}

export function DropdownIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6885 7.01872C11.8829 6.82259 11.8815 6.50601 11.6854 6.31162C11.4893 6.11723 11.1727 6.11864 10.9783 6.31478L9.81342 7.49009C9.34066 7.96708 9.0153 8.29429 8.73961 8.51569C8.47181 8.73075 8.2998 8.80453 8.14575 8.82417C8.04902 8.8365 7.95114 8.8365 7.85441 8.82417C7.70036 8.80453 7.52835 8.73075 7.26055 8.51569C6.98487 8.29429 6.65951 7.96708 6.18675 7.49009L5.02188 6.31478C4.82749 6.11864 4.51091 6.11723 4.31478 6.31162C4.11864 6.50601 4.11723 6.82259 4.31162 7.01872L5.49748 8.21521C5.94411 8.66586 6.30914 9.03417 6.63439 9.29538C6.9726 9.567 7.3159 9.76362 7.72797 9.81614C7.90866 9.83917 8.09151 9.83917 8.27219 9.81614C8.68426 9.76362 9.02756 9.567 9.36578 9.29538C9.69102 9.03417 10.0561 8.66586 10.5027 8.21521L11.6885 7.01872Z"
        fill="#020203"
      />
    </svg>
  );
}

export function AppleIcon() {
  return (
    <svg
      width="28"
      height="34"
      viewBox="0 0 28 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.1707 17.7191C23.132 13.5292 26.6894 11.4908 26.852 11.3959C24.8374 8.53203 21.7147 8.14073 20.6174 8.10953C17.9947 7.84043 15.4507 9.63963 14.1147 9.63963C12.752 9.63963 10.6947 8.13553 8.47737 8.17973C5.62403 8.22263 2.9547 9.83333 1.4907 12.3345C-1.53063 17.4344 0.722703 24.9289 3.61737 29.0512C5.06537 31.0701 6.75737 33.3243 8.97204 33.245C11.1387 33.1579 11.948 31.8982 14.5627 31.8982C17.1534 31.8982 17.9134 33.245 20.172 33.1943C22.4974 33.1579 23.9614 31.1663 25.3587 29.1292C27.032 26.8152 27.704 24.5363 27.7307 24.4193C27.676 24.4011 23.2147 22.741 23.1707 17.7191Z"
        fill="white"
      />
      <path
        d="M18.904 5.39773C20.0694 3.97683 20.8667 2.04373 20.6454 0.0820312C18.9587 0.154831 16.8494 1.21953 15.6347 2.60923C14.56 3.83383 13.6 5.84103 13.848 7.72863C15.7427 7.86643 17.688 6.79653 18.904 5.39773Z"
        fill="white"
      />
    </svg>
  );
}

export function TwitterIcon() {
  return (
    <svg
      width="24"
      height="20"
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.643 2.93708C22.808 3.30708 21.911 3.55708 20.968 3.67008C21.941 3.08787 22.669 2.17154 23.016 1.09208C22.1019 1.63507 21.1014 2.01727 20.058 2.22208C19.3564 1.47294 18.4271 0.976403 17.4143 0.809551C16.4016 0.642699 15.3621 0.814868 14.4572 1.29933C13.5524 1.78379 12.8328 2.55344 12.4102 3.48878C11.9875 4.42412 11.8855 5.47283 12.12 6.47208C10.2677 6.37907 8.45564 5.89763 6.80144 5.05898C5.14723 4.22034 3.68785 3.04324 2.51801 1.60408C2.11801 2.29408 1.88801 3.09408 1.88801 3.94608C1.88757 4.71307 2.07644 5.46832 2.43789 6.14481C2.79934 6.8213 3.32217 7.39812 3.96001 7.82408C3.22029 7.80054 2.49688 7.60066 1.85001 7.24108V7.30108C1.84994 8.37682 2.22204 9.41945 2.90319 10.2521C3.58434 11.0847 4.53258 11.656 5.58701 11.8691C4.9008 12.0548 4.18135 12.0821 3.48301 11.9491C3.78051 12.8747 4.36001 13.6841 5.14038 14.264C5.92075 14.8439 6.86293 15.1653 7.83501 15.1831C6.18484 16.4785 4.1469 17.1812 2.04901 17.1781C1.67739 17.1782 1.30609 17.1565 0.937012 17.1131C3.06649 18.4823 5.54535 19.2089 8.07701 19.2061C16.647 19.2061 21.332 12.1081 21.332 5.95208C21.332 5.75208 21.327 5.55008 21.318 5.35008C22.2293 4.69105 23.0159 3.87497 23.641 2.94008L23.643 2.93708Z"
        fill="#FDFDFF"
      />
    </svg>
  );
}

export function FacebookIcon() {
  return (
    <svg
      width="11"
      height="19"
      viewBox="0 0 11 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 1.50005C11 1.36745 10.9473 1.24027 10.8536 1.1465C10.7598 1.05273 10.6326 1.00005 10.5 1.00005H8C6.74112 0.937344 5.5086 1.37544 4.57172 2.21863C3.63485 3.06182 3.06978 4.24155 3 5.50005V8.20005H0.5C0.367392 8.20005 0.240215 8.25273 0.146447 8.3465C0.0526785 8.44027 0 8.56744 0 8.70005V11.3001C0 11.4327 0.0526785 11.5598 0.146447 11.6536C0.240215 11.7474 0.367392 11.8001 0.5 11.8001H3V18.5001C3 18.6327 3.05268 18.7598 3.14645 18.8536C3.24021 18.9474 3.36739 19.0001 3.5 19.0001H6.5C6.63261 19.0001 6.75979 18.9474 6.85355 18.8536C6.94732 18.7598 7 18.6327 7 18.5001V11.8001H9.62C9.73119 11.8017 9.83974 11.7661 9.92848 11.6991C10.0172 11.6321 10.0811 11.5374 10.11 11.4301L10.83 8.83005C10.8499 8.75618 10.8526 8.67872 10.8378 8.60364C10.8231 8.52857 10.7913 8.45788 10.7449 8.39702C10.6985 8.33617 10.6388 8.28676 10.5704 8.25261C10.5019 8.21846 10.4265 8.20048 10.35 8.20005H7V5.50005C7.02487 5.25253 7.14111 5.02317 7.32602 4.85675C7.51093 4.69033 7.75123 4.59881 8 4.60005H10.5C10.6326 4.60005 10.7598 4.54737 10.8536 4.45361C10.9473 4.35984 11 4.23266 11 4.10005V1.50005Z"
        fill="#FDFDFF"
      />
    </svg>
  );
}

export function LinkedIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.429 6.969H11.143V8.819C11.678 7.755 13.05 6.799 15.111 6.799C19.062 6.799 20 8.917 20 12.803V20H16V13.688C16 11.475 15.465 10.227 14.103 10.227C12.214 10.227 11.429 11.572 11.429 13.687V20H7.429V6.969ZM0.57 19.83H4.57V6.799H0.57V19.83ZM5.143 2.55C5.14315 2.88528 5.07666 3.21724 4.94739 3.52659C4.81812 3.83594 4.62865 4.11651 4.39 4.352C3.9064 4.83262 3.25181 5.10165 2.57 5.1C1.88939 5.09954 1.23631 4.8312 0.752 4.353C0.514211 4.11671 0.325386 3.83582 0.196344 3.52643C0.0673015 3.21704 0.000579132 2.88522 0 2.55C0 1.873 0.27 1.225 0.753 0.747C1.23689 0.268158 1.89024 -0.000299211 2.571 2.50265e-07C3.253 2.50265e-07 3.907 0.269 4.39 0.747C4.872 1.225 5.143 1.873 5.143 2.55Z"
        fill="#FDFDFF"
      />
    </svg>
  );
}

export function InstagramIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0001 6.87579C8.2798 6.87579 6.87589 8.2797 6.87589 10C6.87589 11.7203 8.2798 13.1242 10.0001 13.1242C11.7204 13.1242 13.1243 11.7203 13.1243 10C13.1243 8.2797 11.7204 6.87579 10.0001 6.87579ZM19.3704 10C19.3704 8.70626 19.3821 7.42423 19.3095 6.13283C19.2368 4.63283 18.8946 3.30158 17.7978 2.2047C16.6985 1.10548 15.3696 0.765639 13.8696 0.692982C12.5759 0.620326 11.2939 0.632045 10.0025 0.632045C8.7087 0.632045 7.42667 0.620326 6.13527 0.692982C4.63527 0.765639 3.30402 1.10783 2.20714 2.2047C1.10792 3.30392 0.76808 4.63283 0.695424 6.13283C0.622767 7.42658 0.634486 8.70861 0.634486 10C0.634486 11.2914 0.622767 12.5758 0.695424 13.8672C0.76808 15.3672 1.11027 16.6985 2.20714 17.7953C3.30636 18.8945 4.63527 19.2344 6.13527 19.307C7.42902 19.3797 8.71105 19.368 10.0025 19.368C11.2962 19.368 12.5782 19.3797 13.8696 19.307C15.3696 19.2344 16.7009 18.8922 17.7978 17.7953C18.897 16.6961 19.2368 15.3672 19.3095 13.8672C19.3845 12.5758 19.3704 11.2938 19.3704 10ZM10.0001 14.807C7.33995 14.807 5.19308 12.6602 5.19308 10C5.19308 7.33986 7.33995 5.19298 10.0001 5.19298C12.6603 5.19298 14.8071 7.33986 14.8071 10C14.8071 12.6602 12.6603 14.807 10.0001 14.807ZM15.004 6.11876C14.3829 6.11876 13.8814 5.6172 13.8814 4.99611C13.8814 4.37501 14.3829 3.87345 15.004 3.87345C15.6251 3.87345 16.1267 4.37501 16.1267 4.99611C16.1269 5.14359 16.0979 5.28966 16.0416 5.42595C15.9852 5.56224 15.9026 5.68607 15.7983 5.79036C15.694 5.89464 15.5701 5.97733 15.4339 6.03368C15.2976 6.09004 15.1515 6.11895 15.004 6.11876Z"
        fill="#FDFDFF"
      />
    </svg>
  );
}

export function Copyright() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99992 15.1666C4.04659 15.1666 0.833252 11.9533 0.833252 7.99992C0.833252 4.04659 4.04659 0.833252 7.99992 0.833252C11.9533 0.833252 15.1666 4.04659 15.1666 7.99992C15.1666 11.9533 11.9533 15.1666 7.99992 15.1666ZM7.99992 1.83325C4.59992 1.83325 1.83325 4.59992 1.83325 7.99992C1.83325 11.3999 4.59992 14.1666 7.99992 14.1666C11.3999 14.1666 14.1666 11.3999 14.1666 7.99992C14.1666 4.59992 11.3999 1.83325 7.99992 1.83325Z"
        fill="#77778D"
      />
      <path
        d="M8.16007 11.1666C6.41341 11.1666 4.99341 9.74659 4.99341 7.99992C4.99341 6.25325 6.41341 4.83325 8.16007 4.83325C8.92674 4.83325 9.67341 5.11325 10.2467 5.62659C10.4534 5.80659 10.4734 6.12659 10.2934 6.33325C10.1134 6.53992 9.79342 6.55992 9.58675 6.37992C9.19342 6.03326 8.68674 5.83993 8.16007 5.83993C6.96674 5.83993 5.99341 6.81326 5.99341 8.00659C5.99341 9.19993 6.96674 10.1733 8.16007 10.1733C8.68007 10.1733 9.19342 9.97993 9.58675 9.63326C9.79342 9.45326 10.1134 9.47327 10.2934 9.67993C10.4734 9.8866 10.4534 10.2066 10.2467 10.3866C9.66674 10.8866 8.92674 11.1666 8.16007 11.1666Z"
        fill="#77778D"
      />
    </svg>
  );
}

export function ChatIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.66675 11.0001C3.66675 6.94999 6.94999 3.66675 11.0001 3.66675V3.66675C15.0502 3.66675 18.3334 6.94999 18.3334 11.0001V15.6667C18.3334 16.2867 18.3334 16.5967 18.2653 16.8511C18.0803 17.5412 17.5412 18.0803 16.8511 18.2653C16.5967 18.3334 16.2867 18.3334 15.6667 18.3334H11.0001C6.95 18.3334 3.66675 15.0502 3.66675 11.0001V11.0001Z"
        stroke="white"
      />
      <path
        d="M8.25 10.0833L13.75 10.0833"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11 13.75H13.75"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function CartIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.19 17.75H7.53999C6.54999 17.75 5.59999 17.33 4.92999 16.6C4.25999 15.87 3.92 14.89 4 13.9L4.83 3.94C4.86 3.63 4.74999 3.33001 4.53999 3.10001C4.32999 2.87001 4.04 2.75 3.73 2.75H2C1.59 2.75 1.25 2.41 1.25 2C1.25 1.59 1.59 1.25 2 1.25H3.74001C4.47001 1.25 5.15999 1.56 5.64999 2.09C5.91999 2.39 6.12 2.74 6.23 3.13H18.72C19.73 3.13 20.66 3.53 21.34 4.25C22.01 4.98 22.35 5.93 22.27 6.94L21.73 14.44C21.62 16.27 20.02 17.75 18.19 17.75ZM6.28 4.62L5.5 14.02C5.45 14.6 5.64 15.15 6.03 15.58C6.42 16.01 6.95999 16.24 7.53999 16.24H18.19C19.23 16.24 20.17 15.36 20.25 14.32L20.79 6.82001C20.83 6.23001 20.64 5.67001 20.25 5.26001C19.86 4.84001 19.32 4.60999 18.73 4.60999H6.28V4.62Z"
        fill="#292D32"
      />
      <path
        d="M16.25 22.75C15.15 22.75 14.25 21.85 14.25 20.75C14.25 19.65 15.15 18.75 16.25 18.75C17.35 18.75 18.25 19.65 18.25 20.75C18.25 21.85 17.35 22.75 16.25 22.75ZM16.25 20.25C15.97 20.25 15.75 20.47 15.75 20.75C15.75 21.03 15.97 21.25 16.25 21.25C16.53 21.25 16.75 21.03 16.75 20.75C16.75 20.47 16.53 20.25 16.25 20.25Z"
        fill="#292D32"
      />
      <path
        d="M8.25 22.75C7.15 22.75 6.25 21.85 6.25 20.75C6.25 19.65 7.15 18.75 8.25 18.75C9.35 18.75 10.25 19.65 10.25 20.75C10.25 21.85 9.35 22.75 8.25 22.75ZM8.25 20.25C7.97 20.25 7.75 20.47 7.75 20.75C7.75 21.03 7.97 21.25 8.25 21.25C8.53 21.25 8.75 21.03 8.75 20.75C8.75 20.47 8.53 20.25 8.25 20.25Z"
        fill="#292D32"
      />
      <path
        d="M21 8.75H9C8.59 8.75 8.25 8.41 8.25 8C8.25 7.59 8.59 7.25 9 7.25H21C21.41 7.25 21.75 7.59 21.75 8C21.75 8.41 21.41 8.75 21 8.75Z"
        fill="#292D32"
      />
    </svg>
  );
}

export function HeartIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 8.77673C18.7932 8.10613 18.4228 7.47603 17.8547 6.91284C17.4075 6.46941 16.9433 6.17698 16.4776 6M10.3993 4.14593C8.72567 3.08425 6.02273 2.08032 3.68853 4.46071C-1.85248 10.1114 7.64984 21 12 21C16.3501 21 25.8525 10.1114 20.3115 4.46072C17.9773 2.08035 15.2744 3.08427 13.6007 4.14593C12.655 4.74582 11.345 4.74582 10.3993 4.14593Z"
        stroke="#1E1D1C"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
}

export function SliderPrevBtn() {
  return (
    <svg
      width="4"
      height="8"
      viewBox="0 0 4 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.68539 1.02175C3.88152 0.827364 3.88293 0.510785 3.68854 0.314654C3.49415 0.118522 3.17757 0.11711 2.98144 0.311499L1.78495 1.49736C1.33431 1.94399 0.965989 2.30902 0.704786 2.63427C0.433166 2.97248 0.236545 3.31578 0.184021 3.72785C0.16099 3.90854 0.160991 4.09138 0.184021 4.27207C0.236545 4.68414 0.433167 5.02744 0.704786 5.36565C0.965988 5.6909 1.3343 6.05593 1.78494 6.50255L2.98144 7.68842C3.17757 7.88281 3.49415 7.8814 3.68854 7.68526C3.88293 7.48913 3.88152 7.17255 3.68539 6.97816L2.51007 5.81329C2.03308 5.34053 1.70588 5.01517 1.48448 4.73949C1.26941 4.47169 1.19563 4.29968 1.176 4.14563C1.16367 4.0489 1.16367 3.95102 1.17599 3.85429C1.19563 3.70024 1.26941 3.52823 1.48448 3.26043C1.70588 2.98474 2.03308 2.65938 2.51007 2.18663L3.68539 1.02175Z"
        fill="#77778D"
      />
    </svg>
  );
}

export function SliderNextBtn() {
  return (
    <svg
      width="4"
      height="8"
      viewBox="0 0 4 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.01872 0.311499C0.822589 0.11711 0.50601 0.118522 0.311621 0.314654C0.117232 0.510785 0.118644 0.827364 0.314776 1.02175L1.49009 2.18662C1.96708 2.65938 2.29429 2.98474 2.51569 3.26043C2.73075 3.52823 2.80453 3.70024 2.82417 3.85429C2.8365 3.95102 2.8365 4.0489 2.82417 4.14563C2.80453 4.29968 2.73075 4.47169 2.51569 4.73949C2.29429 5.01517 1.96708 5.34053 1.49009 5.81329L0.314776 6.97816C0.118644 7.17255 0.117232 7.48913 0.311621 7.68526C0.50601 7.8814 0.822589 7.88281 1.01872 7.68842L2.21521 6.50256C2.66585 6.05593 3.03417 5.6909 3.29538 5.36565C3.567 5.02744 3.76362 4.68414 3.81614 4.27207C3.83917 4.09138 3.83917 3.90854 3.81614 3.72785C3.76362 3.31578 3.567 2.97248 3.29538 2.63427C3.03417 2.30902 2.66586 1.94399 2.21521 1.49736L1.01872 0.311499Z"
        fill="#77778D"
      />
    </svg>
  );
}

export function ShoppingCart() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.2217 20.7084H8.79666C7.64166 20.7084 6.53333 20.2184 5.75166 19.3667C4.96999 18.515 4.57334 17.3717 4.66667 16.2167L5.635 4.59671C5.67 4.23504 5.54166 3.88505 5.29666 3.61671C5.05166 3.34838 4.71333 3.20837 4.35166 3.20837H2.33334C1.855 3.20837 1.45834 2.81171 1.45834 2.33337C1.45834 1.85504 1.855 1.45837 2.33334 1.45837H4.36334C5.21501 1.45837 6.02 1.82004 6.59166 2.43837C6.90666 2.78837 7.14 3.19671 7.26833 3.65171H21.84C23.0183 3.65171 24.1033 4.11837 24.8967 4.95837C25.6783 5.81004 26.075 6.91838 25.9817 8.09671L25.3517 16.8467C25.2233 18.9817 23.3567 20.7084 21.2217 20.7084ZM7.32667 5.39003L6.41667 16.3567C6.35834 17.0334 6.58 17.675 7.035 18.1767C7.49 18.6784 8.11999 18.9467 8.79666 18.9467H21.2217C22.435 18.9467 23.5317 17.92 23.625 16.7067L24.255 7.95672C24.3017 7.26838 24.08 6.61505 23.625 6.13672C23.17 5.64672 22.54 5.37836 21.8517 5.37836H7.32667V5.39003Z"
        fill="black"
      />
      <path
        d="M18.9583 26.5417C17.675 26.5417 16.625 25.4917 16.625 24.2083C16.625 22.925 17.675 21.875 18.9583 21.875C20.2417 21.875 21.2917 22.925 21.2917 24.2083C21.2917 25.4917 20.2417 26.5417 18.9583 26.5417ZM18.9583 23.625C18.6317 23.625 18.375 23.8817 18.375 24.2083C18.375 24.535 18.6317 24.7917 18.9583 24.7917C19.285 24.7917 19.5417 24.535 19.5417 24.2083C19.5417 23.8817 19.285 23.625 18.9583 23.625Z"
        fill="black"
      />
      <path
        d="M9.625 26.5417C8.34166 26.5417 7.29166 25.4917 7.29166 24.2083C7.29166 22.925 8.34166 21.875 9.625 21.875C10.9083 21.875 11.9583 22.925 11.9583 24.2083C11.9583 25.4917 10.9083 26.5417 9.625 26.5417ZM9.625 23.625C9.29833 23.625 9.04166 23.8817 9.04166 24.2083C9.04166 24.535 9.29833 24.7917 9.625 24.7917C9.95166 24.7917 10.2083 24.535 10.2083 24.2083C10.2083 23.8817 9.95166 23.625 9.625 23.625Z"
        fill="black"
      />
      <path
        d="M24.5 10.2084H10.5C10.0217 10.2084 9.625 9.81171 9.625 9.33337C9.625 8.85504 10.0217 8.45837 10.5 8.45837H24.5C24.9783 8.45837 25.375 8.85504 25.375 9.33337C25.375 9.81171 24.9783 10.2084 24.5 10.2084Z"
        fill="black"
      />
    </svg>
  );
}

export function SellerIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.15 26.5416H10.85C5.08667 26.5416 2.63667 24.08 2.63667 18.3283V13.09C2.63667 12.6116 3.03333 12.215 3.51167 12.215C3.99 12.215 4.38667 12.6116 4.38667 13.09V18.3283C4.38667 23.1 6.07833 24.7916 10.85 24.7916H17.1383C21.91 24.7916 23.6017 23.1 23.6017 18.3283V13.09C23.6017 12.6116 23.9983 12.215 24.4767 12.215C24.955 12.215 25.3517 12.6116 25.3517 13.09V18.3283C25.3633 24.08 22.9017 26.5416 17.15 26.5416Z"
        fill="#292D32"
      />
      <path
        d="M14 14.875C12.7167 14.875 11.55 14.3734 10.7217 13.4517C9.89333 12.53 9.50833 11.3284 9.63667 10.045L10.4183 2.25171C10.465 1.80837 10.8383 1.45837 11.2933 1.45837H16.7417C17.1967 1.45837 17.57 1.79671 17.6167 2.25171L18.3983 10.045C18.5267 11.3284 18.1417 12.53 17.3133 13.4517C16.45 14.3734 15.2833 14.875 14 14.875ZM12.075 3.20837L11.375 10.22C11.2933 11.0017 11.5267 11.7367 12.0167 12.2734C13.0083 13.37 14.9917 13.37 15.9833 12.2734C16.4733 11.725 16.7067 10.99 16.625 10.22L15.925 3.20837H12.075Z"
        fill="#292D32"
      />
      <path
        d="M21.3617 14.875C18.9933 14.875 16.8817 12.9617 16.6367 10.605L15.82 2.42671C15.7967 2.18171 15.8783 1.93671 16.0417 1.75004C16.205 1.56337 16.4383 1.45837 16.695 1.45837H20.2533C23.6833 1.45837 25.2817 2.89337 25.76 6.41671L26.0867 9.66004C26.2267 11.0367 25.8067 12.3434 24.9083 13.335C24.01 14.3267 22.75 14.875 21.3617 14.875ZM17.6633 3.20837L18.3867 10.43C18.5383 11.8884 19.8917 13.125 21.3617 13.125C22.2483 13.125 23.0417 12.7867 23.6133 12.1684C24.1733 11.55 24.43 10.7217 24.3483 9.83504L24.0217 6.62671C23.66 3.99004 22.8083 3.20837 20.2533 3.20837H17.6633Z"
        fill="#292D32"
      />
      <path
        d="M6.58 14.875C5.19167 14.875 3.93167 14.3267 3.03334 13.335C2.135 12.3434 1.715 11.0367 1.855 9.66004L2.17 6.45171C2.66 2.89337 4.25834 1.45837 7.68834 1.45837H11.2467C11.4917 1.45837 11.725 1.56337 11.9 1.75004C12.075 1.93671 12.145 2.18171 12.1217 2.42671L11.305 10.605C11.06 12.9617 8.94834 14.875 6.58 14.875ZM7.68834 3.20837C5.13334 3.20837 4.28167 3.97837 3.90834 6.65004L3.59334 9.83504C3.5 10.7217 3.76834 11.55 4.32834 12.1684C4.88834 12.7867 5.68167 13.125 6.58 13.125C8.05 13.125 9.415 11.8884 9.555 10.43L10.2783 3.20837H7.68834Z"
        fill="#292D32"
      />
      <path
        d="M16.9167 26.5417H11.0833C10.605 26.5417 10.2083 26.145 10.2083 25.6667V22.75C10.2083 20.3 11.55 18.9584 14 18.9584C16.45 18.9584 17.7917 20.3 17.7917 22.75V25.6667C17.7917 26.145 17.395 26.5417 16.9167 26.5417ZM11.9583 24.7917H16.0417V22.75C16.0417 21.28 15.47 20.7084 14 20.7084C12.53 20.7084 11.9583 21.28 11.9583 22.75V24.7917Z"
        fill="#292D32"
      />
    </svg>
  );
}

export function BackArrow() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.56994 18.82C9.37994 18.82 9.18994 18.75 9.03994 18.6L2.96994 12.53C2.67994 12.24 2.67994 11.76 2.96994 11.47L9.03994 5.4C9.32994 5.11 9.80994 5.11 10.0999 5.4C10.3899 5.69 10.3899 6.17 10.0999 6.46L4.55994 12L10.0999 17.54C10.3899 17.83 10.3899 18.31 10.0999 18.6C9.95994 18.75 9.75994 18.82 9.56994 18.82Z"
        fill="#292D32"
      />
      <path
        d="M20.5 12.75H3.67004C3.26004 12.75 2.92004 12.41 2.92004 12C2.92004 11.59 3.26004 11.25 3.67004 11.25H20.5C20.91 11.25 21.25 11.59 21.25 12C21.25 12.41 20.91 12.75 20.5 12.75Z"
        fill="#292D32"
      />
    </svg>
  );
}

export function DashboardIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.07 2.81984L3.14001 8.36983C2.36001 8.98983 1.86001 10.2999 2.03001 11.2799L3.36001 19.2398C3.60001 20.6598 4.96 21.8098 6.4 21.8098H17.6C19.03 21.8098 20.4 20.6498 20.64 19.2398L21.97 11.2799C22.13 10.2999 21.63 8.98983 20.86 8.36983L13.93 2.82985C12.86 1.96985 11.13 1.96984 10.07 2.81984Z"
        stroke="#707581"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 15.5C13.3807 15.5 14.5 14.3807 14.5 13C14.5 11.6193 13.3807 10.5 12 10.5C10.6193 10.5 9.5 11.6193 9.5 13C9.5 14.3807 10.6193 15.5 12 15.5Z"
        stroke="#707581"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function OrderIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 13.3C11.87 13.3 11.74 13.27 11.62 13.2L2.79 8.09001C2.44 7.88001 2.31 7.42001 2.52 7.06001C2.73 6.70001 3.19 6.58001 3.55 6.79001L12 11.68L20.4 6.82001C20.76 6.61001 21.22 6.74001 21.43 7.09001C21.64 7.45001 21.51 7.91001 21.16 8.12001L12.39 13.2C12.26 13.26 12.13 13.3 12 13.3Z"
        fill="#707581"
      />
      <path
        d="M12 22.36C11.59 22.36 11.25 22.02 11.25 21.61V12.54C11.25 12.13 11.59 11.79 12 11.79C12.41 11.79 12.75 12.13 12.75 12.54V21.61C12.75 22.02 12.41 22.36 12 22.36Z"
        fill="#707581"
      />
      <path
        d="M12 22.75C11.12 22.75 10.25 22.56 9.56 22.18L4.22 19.21C2.77 18.41 1.64 16.48 1.64 14.82V9.17C1.64 7.51 2.77 5.59 4.22 4.78L9.56 1.82C10.93 1.06 13.07 1.06 14.44 1.82L19.78 4.79C21.23 5.59 22.36 7.52 22.36 9.18V14.83C22.36 16.49 21.23 18.41 19.78 19.22L14.44 22.18C13.75 22.56 12.88 22.75 12 22.75ZM12 2.75C11.37 2.75 10.75 2.88 10.29 3.13L4.95 6.1C3.99 6.63 3.14 8.07 3.14 9.17V14.82C3.14 15.92 3.99 17.36 4.95 17.9L10.29 20.87C11.2 21.38 12.8 21.38 13.71 20.87L19.05 17.9C20.01 17.36 20.86 15.93 20.86 14.82V9.17C20.86 8.07 20.01 6.63 19.05 6.09L13.71 3.12C13.25 2.88 12.63 2.75 12 2.75Z"
        fill="#707581"
      />
    </svg>
  );
}

export function CategoryIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2L3 6L12 10L21 6L12 2Z"
        stroke="#707581"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.71521 9.52797L2.69527 11.3146C2.42442 11.435 2.24987 11.7036 2.24987 12C2.24987 12.2964 2.42442 12.565 2.69527 12.6853L11.6953 16.6853C11.8892 16.7715 12.1106 16.7715 12.3045 16.6853L21.3045 12.6853C21.5753 12.565 21.7499 12.2964 21.7499 12C21.7499 11.7036 21.5753 11.435 21.3045 11.3146L17.2847 9.52802L15.4044 10.3338L19.1532 12L11.9999 15.1792L4.84653 12L8.59545 10.3338L6.71521 9.52797ZM11.7001 7.31248C11.8913 7.22911 12.1086 7.22913 12.2998 7.31254L12 7.44101L11.7001 7.31248Z"
        fill="#707581"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.93718 15.4294L2.69527 17.3147C2.42442 17.4351 2.24987 17.7036 2.24987 18C2.24987 18.2964 2.42442 18.565 2.69527 18.6854L11.6953 22.6854C11.8892 22.7716 12.1106 22.7716 12.3045 22.6854L21.3045 18.6854C21.5753 18.565 21.7499 18.2964 21.7499 18C21.7499 17.7036 21.5753 17.4351 21.3045 17.3147L17.0627 15.4294L15.1825 16.2353L19.1532 18L11.9999 21.1793L4.84653 18L8.81742 16.2352L6.93718 15.4294Z"
        fill="#707581"
      />
    </svg>
  );
}

export function ProductsIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9998 22.6C10.8898 22.6 9.85982 22.13 9.08982 21.29L2.22982 13.75C1.25982 12.69 0.959818 10.82 1.53982 9.51003L4.09983 3.75003C4.79983 2.18003 5.96983 1.41003 7.68983 1.41003H16.2798V2.16003V1.41003C17.9998 1.41003 19.1698 2.17004 19.8698 3.74004L22.4298 9.50003C23.0098 10.81 22.7198 12.68 21.7498 13.74L14.8998 21.29C14.1498 22.13 13.1098 22.6 11.9998 22.6ZM16.2898 2.90004H7.69982C6.38982 2.90004 5.85982 3.48003 5.47982 4.35003L2.91982 10.11C2.57982 10.88 2.77982 12.11 3.33982 12.73L10.1998 20.27C10.6798 20.8 11.3198 21.09 11.9998 21.09C12.6798 21.09 13.3198 20.8 13.7998 20.27L20.6498 12.72C21.2198 12.09 21.4198 10.87 21.0698 10.1L18.5098 4.34003C18.1298 3.48003 17.5998 2.90004 16.2898 2.90004Z"
        fill="#707581"
      />
      <path
        d="M3.5 8.74999C3.09 8.74999 2.75 8.40999 2.75 7.99999C2.75 7.58999 3.09 7.24999 3.5 7.24999L20.5 7.23999C20.91 7.23999 21.25 7.57999 21.25 7.98999C21.25 8.39999 20.91 8.73999 20.5 8.73999L3.5 8.74999Z"
        fill="#707581"
      />
    </svg>
  );
}

export function InventoryIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2936_3203)">
        <path
          d="M23.42 24C15.8089 24 8.19767 24 0.586478 24C0.312788 23.8827 0.117296 23.6871 0 23.4134C0 19.6328 0 15.8523 0 12.0717C0.188976 11.6219 0.527831 11.472 1.01005 11.4785C2.48927 11.4981 3.97502 11.4851 5.46077 11.4851C5.54548 11.4851 5.63671 11.4851 5.73446 11.4851C5.73446 11.3482 5.73446 11.2439 5.73446 11.1396C5.73446 7.75665 5.73446 4.38023 5.73446 0.997284C5.73446 0.286801 6.01466 0.0130364 6.73147 0.0130364C10.2373 0.0065182 13.7497 0.0130364 17.262 0C17.8355 0 18.259 0.273764 18.259 0.997284C18.2395 4.38675 18.2525 7.77621 18.2525 11.1657C18.2525 11.27 18.2525 11.3743 18.2525 11.4851C18.3763 11.4851 18.4676 11.4851 18.5588 11.4851C20.0445 11.4851 21.5238 11.4851 23.0095 11.4851C23.7263 11.4851 24 11.7588 24 12.4693C24 15.9631 23.9935 19.4568 24.0065 22.9571C24 23.4329 23.8697 23.7914 23.42 24ZM7.31143 11.472C10.4458 11.472 13.5542 11.472 16.669 11.472C16.669 8.17382 16.669 4.88213 16.669 1.59044C15.8023 1.59044 14.9487 1.59044 14.082 1.59044C14.082 1.69473 14.082 1.78599 14.082 1.87072C14.082 2.69853 14.082 3.53286 14.082 4.36067C14.082 4.9082 13.7692 5.22108 13.2153 5.22759C12.4203 5.22759 11.6188 5.22759 10.8238 5.22759C10.2112 5.22759 9.918 4.92776 9.918 4.30853C9.918 3.48723 9.918 2.66594 9.918 1.83813C9.918 1.75339 9.91148 1.66866 9.90497 1.59044C9.01873 1.59044 8.1716 1.59044 7.31795 1.59044C7.31143 4.89517 7.31143 8.17382 7.31143 11.472ZM19.8099 13.0559C19.8099 13.1668 19.8099 13.258 19.8099 13.3427C19.8099 14.1706 19.8099 15.0049 19.8099 15.8327C19.8099 16.3867 19.5037 16.6931 18.9498 16.6996C18.1352 16.7061 17.3207 16.7061 16.5061 16.6996C15.9587 16.6931 15.6459 16.3737 15.6459 15.8262C15.6459 14.9853 15.6459 14.151 15.6459 13.3102C15.6459 13.2254 15.6459 13.1407 15.6459 13.0625C14.675 13.0625 13.7366 13.0625 12.8048 13.0625C12.8048 16.1912 12.8048 19.3004 12.8048 22.4161C16.0174 22.4161 19.2104 22.4161 22.41 22.4161C22.41 19.2873 22.41 16.1716 22.41 13.0494C21.5433 13.0559 20.6962 13.0559 19.8099 13.0559ZM1.57698 22.4226C4.79609 22.4226 7.98914 22.4226 11.1822 22.4226C11.1822 19.2939 11.1822 16.1782 11.1822 13.0625C10.2373 13.0625 9.29894 13.0625 8.34754 13.0625C8.34754 13.1668 8.34754 13.2515 8.34754 13.3362C8.34754 14.151 8.34754 14.9658 8.34754 15.7806C8.34754 16.3933 8.04127 16.6996 7.42873 16.6996C6.64676 16.6996 5.86478 16.6996 5.08281 16.6996C4.47027 16.6996 4.164 16.3933 4.164 15.7806C4.164 14.9593 4.164 14.138 4.164 13.3102C4.164 13.2254 4.15748 13.1407 4.15096 13.0625C3.27125 13.0625 2.41759 13.0625 1.57046 13.0625C1.57698 16.1912 1.57698 19.3004 1.57698 22.4226ZM6.77057 13.0625C6.41216 13.0625 6.08634 13.0625 5.754 13.0625C5.754 13.7534 5.754 14.4313 5.754 15.1222C6.09938 15.1222 6.4252 15.1222 6.77057 15.1222C6.77057 14.4313 6.77057 13.7534 6.77057 13.0625ZM17.2229 13.0559C17.2229 13.7534 17.2229 14.4378 17.2229 15.1222C17.5683 15.1222 17.8941 15.1222 18.2264 15.1222C18.2264 14.4248 18.2264 13.7469 18.2264 13.0559C17.8876 13.0559 17.5683 13.0559 17.2229 13.0559ZM12.505 1.60999C12.1531 1.60999 11.8273 1.60999 11.4885 1.60999C11.4885 2.30092 11.4885 2.9723 11.4885 3.64367C11.8338 3.64367 12.1727 3.64367 12.505 3.64367C12.505 2.95926 12.505 2.29441 12.505 1.60999Z"
          fill="#707581"
        />
      </g>
      <defs>
        <clipPath id="clip0_2936_3203">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

// export function ChatIcon() {
//   return (
//     <svg
//       width="22"
//       height="21"
//       viewBox="0 0 22 21"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//     >
//       <path
//         d="M10.6692 17.9506L11.1051 18.5609L10.6692 17.9506ZM10.7222 17.9128L10.2902 17.2997L10.7222 17.9128ZM13.5703 17.0001L13.5751 17.7501L13.5703 17.0001ZM6.3959 18.5103L7.09226 18.7888L6.3959 18.5103ZM8.05848 19.8154L7.62255 19.2051H7.62255L8.05848 19.8154ZM20.798 13.4069L21.5177 13.6179L20.798 13.4069ZM17.4069 16.798L17.6179 17.5177L17.4069 16.798ZM3.73005 1.54497L4.07054 2.21322L3.73005 1.54497ZM1.54497 3.73005L2.21322 4.07054L1.54497 3.73005ZM18.27 1.54497L17.9295 2.21322L18.27 1.54497ZM20.455 3.73005L19.7868 4.07054L20.455 3.73005ZM7 10.75C6.58579 10.75 6.25 11.0858 6.25 11.5C6.25 11.9142 6.58579 12.25 7 12.25V10.75ZM15 12.25C15.4142 12.25 15.75 11.9142 15.75 11.5C15.75 11.0858 15.4142 10.75 15 10.75V12.25ZM7 6.25C6.58579 6.25 6.25 6.58579 6.25 7C6.25 7.41421 6.58579 7.75 7 7.75V6.25ZM15 7.75C15.4142 7.75 15.75 7.41421 15.75 7C15.75 6.58579 15.4142 6.25 15 6.25V7.75ZM13 0.25H9V1.75H13V0.25ZM0.25 9V13.2283H1.75V9H0.25ZM21.75 10.1842V9H20.25V10.1842H21.75ZM4.77166 17.75H5.37341V16.25H4.77166V17.75ZM8.49441 20.4257L11.1051 18.5609L10.2333 17.3403L7.62255 19.2051L8.49441 20.4257ZM13.6354 17.75H14.1842V16.25H13.6354V17.75ZM11.1051 18.5609C11.1325 18.5413 11.1436 18.5334 11.1543 18.5259L10.2902 17.2997C10.2747 17.3107 10.2592 17.3218 10.2333 17.3403L11.1051 18.5609ZM13.6354 16.25C13.6036 16.25 13.5845 16.25 13.5655 16.2501L13.5751 17.7501C13.5882 17.75 13.6018 17.75 13.6354 17.75V16.25ZM11.1543 18.5259C11.8632 18.0264 12.7079 17.7556 13.5751 17.7501L13.5655 16.2501C12.3922 16.2576 11.2493 16.6239 10.2902 17.2997L11.1543 18.5259ZM5.37341 17.75C5.62191 17.75 5.79183 18.001 5.69954 18.2317L7.09226 18.7888C7.57867 17.5728 6.68311 16.25 5.37341 16.25V17.75ZM5.69954 18.2317C5.01288 19.9484 6.9899 21.5003 8.49441 20.4257L7.62255 19.2051C7.33709 19.409 6.96197 19.1145 7.09226 18.7888L5.69954 18.2317ZM20.25 10.1842C20.25 11.9261 20.2424 12.6363 20.0783 13.1958L21.5177 13.6179C21.7576 12.7996 21.75 11.8206 21.75 10.1842H20.25ZM14.1842 17.75C15.8206 17.75 16.7996 17.7576 17.6179 17.5177L17.1958 16.0783C16.6363 16.2424 15.9261 16.25 14.1842 16.25V17.75ZM20.0783 13.1958C19.671 14.5848 18.5848 15.671 17.1958 16.0783L17.6179 17.5177C19.4971 16.9667 20.9667 15.4971 21.5177 13.6179L20.0783 13.1958ZM0.25 13.2283C0.25 15.7256 2.27441 17.75 4.77166 17.75V16.25C3.10284 16.25 1.75 14.8972 1.75 13.2283H0.25ZM9 0.25C7.61224 0.25 6.52632 0.249417 5.65494 0.320612C4.77479 0.392522 4.04768 0.541378 3.38955 0.876713L4.07054 2.21322C4.48197 2.00359 4.9897 1.87996 5.77708 1.81563C6.57322 1.75058 7.58749 1.75 9 1.75V0.25ZM1.75 9C1.75 7.58749 1.75058 6.57322 1.81563 5.77708C1.87996 4.9897 2.00359 4.48197 2.21322 4.07054L0.876713 3.38955C0.541378 4.04768 0.392522 4.77479 0.320612 5.65494C0.249417 6.52632 0.25 7.61224 0.25 9H1.75ZM3.38955 0.876713C2.30762 1.42798 1.42798 2.30762 0.876713 3.38955L2.21322 4.07054C2.62068 3.27085 3.27085 2.62068 4.07054 2.21322L3.38955 0.876713ZM13 1.75C14.4125 1.75 15.4268 1.75058 16.2229 1.81563C17.0103 1.87996 17.518 2.00359 17.9295 2.21322L18.6104 0.876713C17.9523 0.541378 17.2252 0.392522 16.3451 0.320612C15.4737 0.249417 14.3878 0.25 13 0.25V1.75ZM21.75 9C21.75 7.61224 21.7506 6.52632 21.6794 5.65494C21.6075 4.77479 21.4586 4.04768 21.1233 3.38955L19.7868 4.07054C19.9964 4.48197 20.12 4.9897 20.1844 5.77708C20.2494 6.57322 20.25 7.58749 20.25 9H21.75ZM17.9295 2.21322C18.7291 2.62068 19.3793 3.27085 19.7868 4.07054L21.1233 3.38955C20.572 2.30762 19.6924 1.42798 18.6104 0.876713L17.9295 2.21322ZM7 12.25H15V10.75H7V12.25ZM7 7.75H15V6.25H7V7.75Z"
//         fill="#707581"
//       />
//     </svg>
//   );
// }

export function ChatIcon2() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6692 18.9506L12.1051 19.5609L11.6692 18.9506ZM11.7222 18.9128L11.2902 18.2997L11.7222 18.9128ZM14.5703 18.0001L14.5751 18.7501L14.5703 18.0001ZM7.3959 19.5103L8.09226 19.7888L7.3959 19.5103ZM9.05848 20.8154L8.62255 20.2051H8.62255L9.05848 20.8154ZM21.798 14.4069L22.5177 14.6179L21.798 14.4069ZM18.4069 17.798L18.6179 18.5177L18.4069 17.798ZM4.73005 2.54497L5.07054 3.21322L4.73005 2.54497ZM2.54497 4.73005L3.21322 5.07054L2.54497 4.73005ZM19.27 2.54497L18.9295 3.21322L19.27 2.54497ZM21.455 4.73005L20.7868 5.07054L21.455 4.73005ZM8 11.75C7.58579 11.75 7.25 12.0858 7.25 12.5C7.25 12.9142 7.58579 13.25 8 13.25V11.75ZM16 13.25C16.4142 13.25 16.75 12.9142 16.75 12.5C16.75 12.0858 16.4142 11.75 16 11.75V13.25ZM8 7.25C7.58579 7.25 7.25 7.58579 7.25 8C7.25 8.41421 7.58579 8.75 8 8.75V7.25ZM16 8.75C16.4142 8.75 16.75 8.41421 16.75 8C16.75 7.58579 16.4142 7.25 16 7.25V8.75ZM14 1.25H10V2.75H14V1.25ZM1.25 10V14.2283H2.75V10H1.25ZM22.75 11.1842V10H21.25V11.1842H22.75ZM5.77166 18.75H6.37341V17.25H5.77166V18.75ZM9.49441 21.4257L12.1051 19.5609L11.2333 18.3403L8.62255 20.2051L9.49441 21.4257ZM14.6354 18.75H15.1842V17.25H14.6354V18.75ZM12.1051 19.5609C12.1325 19.5413 12.1436 19.5334 12.1543 19.5259L11.2902 18.2997C11.2747 18.3107 11.2592 18.3218 11.2333 18.3403L12.1051 19.5609ZM14.6354 17.25C14.6036 17.25 14.5845 17.25 14.5655 17.2501L14.5751 18.7501C14.5882 18.75 14.6018 18.75 14.6354 18.75V17.25ZM12.1543 19.5259C12.8632 19.0264 13.7079 18.7556 14.5751 18.7501L14.5655 17.2501C13.3922 17.2576 12.2493 17.6239 11.2902 18.2997L12.1543 19.5259ZM6.37341 18.75C6.62191 18.75 6.79183 19.001 6.69954 19.2317L8.09226 19.7888C8.57867 18.5728 7.68311 17.25 6.37341 17.25V18.75ZM6.69954 19.2317C6.01288 20.9484 7.9899 22.5003 9.49441 21.4257L8.62255 20.2051C8.33709 20.409 7.96197 20.1145 8.09226 19.7888L6.69954 19.2317ZM21.25 11.1842C21.25 12.9261 21.2424 13.6363 21.0783 14.1958L22.5177 14.6179C22.7576 13.7996 22.75 12.8206 22.75 11.1842H21.25ZM15.1842 18.75C16.8206 18.75 17.7996 18.7576 18.6179 18.5177L18.1958 17.0783C17.6363 17.2424 16.9261 17.25 15.1842 17.25V18.75ZM21.0783 14.1958C20.671 15.5848 19.5848 16.671 18.1958 17.0783L18.6179 18.5177C20.4971 17.9667 21.9667 16.4971 22.5177 14.6179L21.0783 14.1958ZM1.25 14.2283C1.25 16.7256 3.27441 18.75 5.77166 18.75V17.25C4.10284 17.25 2.75 15.8972 2.75 14.2283H1.25ZM10 1.25C8.61224 1.25 7.52632 1.24942 6.65494 1.32061C5.77479 1.39252 5.04768 1.54138 4.38955 1.87671L5.07054 3.21322C5.48197 3.00359 5.9897 2.87996 6.77708 2.81563C7.57322 2.75058 8.58749 2.75 10 2.75V1.25ZM2.75 10C2.75 8.58749 2.75058 7.57322 2.81563 6.77708C2.87996 5.9897 3.00359 5.48197 3.21322 5.07054L1.87671 4.38955C1.54138 5.04768 1.39252 5.77479 1.32061 6.65494C1.24942 7.52632 1.25 8.61224 1.25 10H2.75ZM4.38955 1.87671C3.30762 2.42798 2.42798 3.30762 1.87671 4.38955L3.21322 5.07054C3.62068 4.27085 4.27085 3.62068 5.07054 3.21322L4.38955 1.87671ZM14 2.75C15.4125 2.75 16.4268 2.75058 17.2229 2.81563C18.0103 2.87996 18.518 3.00359 18.9295 3.21322L19.6104 1.87671C18.9523 1.54138 18.2252 1.39252 17.3451 1.32061C16.4737 1.24942 15.3878 1.25 14 1.25V2.75ZM22.75 10C22.75 8.61224 22.7506 7.52632 22.6794 6.65494C22.6075 5.77479 22.4586 5.04768 22.1233 4.38955L20.7868 5.07054C20.9964 5.48197 21.12 5.9897 21.1844 6.77708C21.2494 7.57322 21.25 8.58749 21.25 10H22.75ZM18.9295 3.21322C19.7291 3.62068 20.3793 4.27085 20.7868 5.07054L22.1233 4.38955C21.572 3.30762 20.6924 2.42798 19.6104 1.87671L18.9295 3.21322ZM8 13.25H16V11.75H8V13.25ZM8 8.75H16V7.25H8V8.75Z"
        fill="#707581"
      />
    </svg>
  );
}

export function SearchIconTopBar() {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.52637 16.3125C5.28887 16.3125 1.83887 12.8625 1.83887 8.625C1.83887 4.3875 5.28887 0.9375 9.52637 0.9375C13.7639 0.9375 17.2139 4.3875 17.2139 8.625C17.2139 12.8625 13.7639 16.3125 9.52637 16.3125ZM9.52637 2.0625C5.90387 2.0625 2.96387 5.01 2.96387 8.625C2.96387 12.24 5.90387 15.1875 9.52637 15.1875C13.1489 15.1875 16.0889 12.24 16.0889 8.625C16.0889 5.01 13.1489 2.0625 9.52637 2.0625Z"
        fill="#707581"
      />
      <path
        d="M17.4014 17.0625C17.2589 17.0625 17.1164 17.01 17.0039 16.8975L15.5039 15.3975C15.2864 15.18 15.2864 14.82 15.5039 14.6025C15.7214 14.385 16.0814 14.385 16.2989 14.6025L17.7989 16.1025C18.0164 16.32 18.0164 16.68 17.7989 16.8975C17.6864 17.01 17.5439 17.0625 17.4014 17.0625Z"
        fill="#707581"
      />
    </svg>
  );
}

export function NotificationIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.594 3.80426C13.7998 3.44749 12.9209 3.25 12 3.25C8.77137 3.25 6.05901 5.67767 5.70247 8.88659L5.45066 11.1528L5.44451 11.2078C5.32765 12.2261 4.99619 13.2081 4.47198 14.0889L4.44357 14.1364L3.86554 15.0998L3.84611 15.1321C3.60044 15.5416 3.38737 15.8966 3.2471 16.1945C3.10499 16.4962 2.97336 16.8655 3.03761 17.2727C3.10354 17.6906 3.3186 18.0704 3.64298 18.3419C3.95911 18.6066 4.34353 18.6837 4.67538 18.7171C5.00296 18.75 5.41705 18.75 5.89452 18.75L5.93227 18.75H18.0678L18.1056 18.75C18.583 18.75 18.9971 18.75 19.3247 18.7171C19.6565 18.6837 20.041 18.6066 20.3571 18.3419C20.6815 18.0704 20.8965 17.6906 20.9625 17.2727C21.0267 16.8655 20.8951 16.4962 20.753 16.1945C20.6127 15.8966 20.3997 15.5416 20.154 15.1322L20.154 15.1322L20.1345 15.0998L19.5565 14.1364L19.5281 14.0889C19.0039 13.2081 18.6724 12.2261 18.5556 11.2078L18.5494 11.1528L18.5001 10.7092C18.0436 10.894 17.5453 10.997 17.0232 10.9999L17.0586 11.3185L17.0653 11.3788C17.2064 12.6078 17.6064 13.793 18.2391 14.8561L18.2703 14.9081L18.8483 15.8715C19.119 16.3227 19.2918 16.6124 19.3959 16.8336C19.4599 16.9694 19.4748 17.0337 19.4782 17.0527C19.4675 17.1024 19.4419 17.1477 19.4048 17.1824C19.3868 17.1893 19.324 17.2096 19.1745 17.2246C18.9313 17.2491 18.5939 17.25 18.0678 17.25H5.93227C5.40613 17.25 5.06876 17.2491 4.82553 17.2246C4.67612 17.2096 4.61333 17.1893 4.59528 17.1824C4.55819 17.1477 4.53257 17.1024 4.52185 17.0527C4.52527 17.0337 4.54015 16.9694 4.60413 16.8336C4.70829 16.6124 4.88108 16.3227 5.15178 15.8715L5.72981 14.9081L5.76098 14.8561C6.39365 13.793 6.7937 12.6078 6.93473 11.3788L6.94149 11.3185L7.19329 9.05224C7.46543 6.60297 9.53569 4.75 12 4.75C12.5352 4.75 13.0519 4.8374 13.5355 4.99933C13.8052 4.53337 14.1661 4.12686 14.594 3.80426ZM16.4508 5.07634C15.9419 5.22136 15.5158 5.56287 15.2598 6.01362C16.0862 6.7676 16.6528 7.8075 16.7995 8.99007C16.8654 8.99664 16.9323 9 17 9C17.4742 9 17.9099 8.83496 18.2527 8.5592C18.0299 7.19801 17.38 5.99292 16.4508 5.07634Z"
        fill="#707581"
      />
      <path
        d="M9.10222 18.4059C9.27315 19.1501 9.64978 19.8077 10.1737 20.2767C10.6976 20.7458 11.3396 21 12 21C12.6604 21 13.3024 20.7458 13.8263 20.2767C14.3502 19.8077 14.7269 19.1501 14.8978 18.4059"
        stroke="#707581"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <circle cx="16.6968" cy="7.13116" r="3" fill="#DBBB51" />
    </svg>
  );
}

export function Dropdown() {
  return (
    <svg
      width="14"
      height="7"
      viewBox="0 0 14 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7354 1.62649C14.0904 1.25206 14.0878 0.647682 13.7297 0.276575C13.3715 -0.094531 12.7934 -0.0918346 12.4385 0.282598L10.3113 2.52638C9.44801 3.437 8.85387 4.06166 8.35045 4.48433C7.86143 4.89491 7.54732 5.03577 7.26601 5.07326C7.08937 5.09679 6.91063 5.09679 6.73399 5.07326C6.45268 5.03577 6.13857 4.89492 5.64956 4.48434C5.14613 4.06166 4.55199 3.43701 3.6887 2.52638L1.56154 0.282599C1.20657 -0.0918337 0.628464 -0.0945301 0.270311 0.276576C-0.0878418 0.647683 -0.090421 1.25206 0.26455 1.62649L2.43003 3.91069C3.24561 4.77102 3.91219 5.47417 4.50612 5.97284C5.12374 6.49138 5.75062 6.86675 6.50311 6.96702C6.83305 7.01099 7.16695 7.01099 7.49689 6.96702C8.24938 6.86675 8.87626 6.49138 9.49388 5.97284C10.0878 5.47417 10.7544 4.77103 11.57 3.9107L13.7354 1.62649Z"
        fill="#5C5C5C"
      />
    </svg>
  );
}

export function ArrowRight() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4301 18.07L20.5001 12L14.4301 5.93001"
        stroke="#707581"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.5 12L20.33 12"
        stroke="#707581"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function PlusIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 6L12 18" stroke="black" stroke-linecap="round" />
      <path d="M18 12L6 12" stroke="black" stroke-linecap="round" />
    </svg>
  );
}

export function StarReviewIcon() {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.30725 3.21986C7.94932 1.61918 8.27036 0.818834 8.79193 0.70791C8.92908 0.678744 9.07083 0.678744 9.20797 0.70791C9.72955 0.818834 10.0506 1.61918 10.6927 3.21986C11.0578 4.13014 11.2404 4.58528 11.582 4.89485C11.6778 4.98168 11.7818 5.05901 11.8926 5.12576C12.2874 5.36374 12.7803 5.40788 13.7661 5.49617C15.4348 5.64562 16.2692 5.72034 16.524 6.19609C16.5768 6.29462 16.6127 6.4013 16.6302 6.51169C16.7146 7.04472 16.1012 7.60278 14.8744 8.7189L14.5338 9.02884C13.9602 9.55065 13.6735 9.81155 13.5076 10.1372C13.4081 10.3325 13.3414 10.5428 13.3101 10.7598C13.258 11.1215 13.342 11.5 13.5099 12.2569L13.5699 12.5274C13.8711 13.8849 14.0217 14.5637 13.8337 14.8973C13.6649 15.197 13.3538 15.3889 13.0102 15.4053C12.6277 15.4236 12.0887 14.9844 11.0107 14.106C10.3005 13.5273 9.94542 13.2379 9.55121 13.1249C9.19097 13.0216 8.80894 13.0216 8.44869 13.1249C8.05448 13.2379 7.69938 13.5273 6.98917 14.106C5.91119 14.9844 5.37221 15.4236 4.98968 15.4053C4.64609 15.3889 4.33504 15.197 4.16617 14.8973C3.97818 14.5637 4.12878 13.8849 4.42997 12.5274L4.48998 12.2569C4.65794 11.5 4.74191 11.1215 4.6898 10.7598C4.65854 10.5428 4.59182 10.3325 4.49232 10.1372C4.32645 9.81155 4.03968 9.55065 3.46613 9.02884L3.12546 8.7189C1.89867 7.60278 1.28527 7.04472 1.36975 6.51169C1.38724 6.4013 1.42312 6.29462 1.47589 6.19608C1.73069 5.72034 2.56507 5.64562 4.23384 5.49617C5.21962 5.40788 5.71251 5.36374 6.10735 5.12576C6.2181 5.05901 6.32211 4.98168 6.41793 4.89485C6.75954 4.58528 6.94211 4.13014 7.30725 3.21986Z"
        fill="#DBBB51"
        stroke="#DBBB51"
      />
    </svg>
  );
}

export function SmallStar() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.58945 3.01655C6.12451 1.68265 6.39205 1.01569 6.82669 0.923258C6.94098 0.898953 7.0591 0.898953 7.17339 0.923258C7.60804 1.01569 7.87557 1.68265 8.41063 3.01655C8.71491 3.77512 8.86705 4.1544 9.15173 4.41238C9.23157 4.48473 9.31825 4.54918 9.41054 4.6048C9.73957 4.80312 10.1503 4.8399 10.9718 4.91347C12.3624 5.03801 13.0578 5.10029 13.2701 5.49674C13.3141 5.57885 13.344 5.66775 13.3585 5.75974C13.4289 6.20393 12.9178 6.66898 11.8955 7.59908L11.6116 7.85737C11.1336 8.2922 10.8946 8.50962 10.7564 8.78096C10.6735 8.94373 10.6179 9.11902 10.5918 9.29982C10.5484 9.60122 10.6184 9.91663 10.7584 10.5475L10.8084 10.7728C11.0594 11.9041 11.1849 12.4698 11.0282 12.7478C10.8875 12.9975 10.6283 13.1574 10.3419 13.1711C10.0232 13.1863 9.57401 12.8203 8.6757 12.0883C8.08385 11.6061 7.78793 11.3649 7.45943 11.2707C7.15922 11.1846 6.84086 11.1846 6.54066 11.2707C6.21215 11.3649 5.91623 11.6061 5.32439 12.0883C4.42608 12.8203 3.97692 13.1863 3.65815 13.1711C3.37182 13.1574 3.11261 12.9975 2.97189 12.7478C2.81523 12.4698 2.94073 11.9041 3.19173 10.7728L3.24173 10.5475C3.38169 9.91663 3.45167 9.60122 3.40825 9.29982C3.3822 9.11902 3.3266 8.94373 3.24368 8.78096C3.10545 8.50962 2.86648 8.29221 2.38852 7.85737L2.10463 7.59908C1.08231 6.66898 0.571144 6.20393 0.641538 5.75974C0.656118 5.66775 0.686017 5.57885 0.729993 5.49674C0.942326 5.10029 1.63764 5.03801 3.02828 4.91347C3.84977 4.8399 4.26051 4.80312 4.58954 4.6048C4.68183 4.54918 4.76851 4.48473 4.84836 4.41238C5.13303 4.1544 5.28517 3.77512 5.58945 3.01655Z"
        fill="#DBBB51"
        stroke="#DBBB51"
      />
    </svg>
  );
}

export function VerticalDots() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10Z"
        fill="#707581"
      />
      <path
        d="M4 10C5.10457 10 6 10.8954 6 12C6 13.1046 5.10457 14 4 14C2.89543 14 2 13.1046 2 12C2 10.8954 2.89543 10 4 10Z"
        fill="#707581"
      />
      <path
        d="M20 10C21.1046 10 22 10.8954 22 12C22 13.1046 21.1046 14 20 14C18.8954 14 18 13.1046 18 12C18 10.8954 18.8954 10 20 10Z"
        fill="#707581"
      />
    </svg>
  );
}

export function Attachment() {
  return (
    <svg
      width="17"
      height="23"
      viewBox="0 0 17 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7082 2.05518C11.3229 1.74964 12.0452 1.65873 12.7602 1.85032C14.3162 2.26723 15.2395 3.86655 14.8226 5.42249L12.4501 14.2768C12.0332 15.8328 10.4339 16.7561 8.87792 16.3392C7.32198 15.9223 6.39862 14.323 6.81553 12.767L7.76453 9.2253C7.87174 8.8252 7.6343 8.41395 7.2342 8.30674C6.8341 8.19954 6.42285 8.43698 6.31564 8.83708L5.36664 12.3788C4.73531 14.7349 6.13355 17.1568 8.4897 17.7881C10.8458 18.4194 13.2677 17.0212 13.899 14.665L16.2715 5.81072C16.9028 3.45458 15.5046 1.03275 13.1484 0.401427C12.067 0.111652 10.9699 0.249988 10.0405 0.711984C9.47065 0.99527 8.96263 1.4007 8.5581 1.90504C8.29893 2.22815 8.35076 2.70019 8.67387 2.95936C8.99699 3.21853 9.46902 3.1667 9.7282 2.84358C9.99477 2.51125 10.3306 2.24292 10.7082 2.05518Z"
        fill="#707581"
      />
      <path
        d="M4.2228 8.2763C4.63972 6.72036 6.23903 5.79699 7.79498 6.21391C9.35092 6.63082 10.2743 8.23013 9.85737 9.78608L8.90837 13.3278C8.80116 13.7279 9.0386 14.1392 9.4387 14.2464C9.8388 14.3536 10.25 14.1161 10.3573 13.716L11.3063 10.1743C11.9376 7.81816 10.5393 5.39634 8.1832 4.76502C5.82706 4.13369 3.40524 5.53193 2.77392 7.88807L0.401407 16.7424C-0.229919 19.0985 1.16832 21.5204 3.52446 22.1517C4.60592 22.4415 5.70301 22.3031 6.63238 21.8411C7.20225 21.5578 7.71027 21.1524 8.1148 20.6481C8.37397 20.325 8.32214 19.8529 7.99903 19.5937C7.67591 19.3346 7.20388 19.3864 6.9447 19.7095C6.67813 20.0419 6.34234 20.3102 5.96467 20.4979C5.35003 20.8035 4.62768 20.8944 3.91269 20.7028C2.35675 20.2859 1.43338 18.6866 1.8503 17.1306L4.2228 8.2763Z"
        fill="#707581"
      />
    </svg>
  );
}

export function SendMessage() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.89999 6.82015L16.39 3.99015C20.2 2.72015 22.27 4.80015 21.01 8.61015L18.18 17.1002C16.28 22.8102 13.16 22.8102 11.26 17.1002L10.42 14.5802L7.89999 13.7402C2.18999 11.8402 2.18999 8.73015 7.89999 6.82015Z"
        stroke="#DBBB51"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.61 14.1496L14.19 10.5596"
        stroke="#DBBB51"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function ChangePassword() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 11.25C17.59 11.25 17.25 10.91 17.25 10.5V8.5C17.25 5.35 16.36 3.25 12 3.25C7.64 3.25 6.75 5.35 6.75 8.5V10.5C6.75 10.91 6.41 11.25 6 11.25C5.59 11.25 5.25 10.91 5.25 10.5V8.5C5.25 5.6 5.95 1.75 12 1.75C18.05 1.75 18.75 5.6 18.75 8.5V10.5C18.75 10.91 18.41 11.25 18 11.25Z"
        fill="#707581"
      />
      <path
        d="M17 23.25H7C2.59 23.25 1.25 21.91 1.25 17.5V15.5C1.25 11.09 2.59 9.75 7 9.75H17C21.41 9.75 22.75 11.09 22.75 15.5V17.5C22.75 21.91 21.41 23.25 17 23.25ZM7 11.25C3.42 11.25 2.75 11.93 2.75 15.5V17.5C2.75 21.07 3.42 21.75 7 21.75H17C20.58 21.75 21.25 21.07 21.25 17.5V15.5C21.25 11.93 20.58 11.25 17 11.25H7Z"
        fill="#707581"
      />
      <path
        d="M8 17.4999C7.87 17.4999 7.74 17.4699 7.62 17.4199C7.49 17.3699 7.39001 17.2999 7.29001 17.2099C7.11001 17.0199 7 16.7699 7 16.4999C7 16.3699 7.02999 16.2399 7.07999 16.1199C7.12999 15.9899 7.20001 15.8899 7.29001 15.7899C7.39001 15.6999 7.49 15.6299 7.62 15.5799C7.98 15.4199 8.42999 15.5099 8.70999 15.7899C8.79999 15.8899 8.87001 15.9999 8.92001 16.1199C8.97001 16.2399 9 16.3699 9 16.4999C9 16.7599 8.88999 17.0199 8.70999 17.2099C8.51999 17.3899 8.26 17.4999 8 17.4999Z"
        fill="#707581"
      />
      <path
        d="M12 17.4999C11.74 17.4999 11.48 17.3899 11.29 17.2099C11.11 17.0199 11 16.7699 11 16.4999C11 16.3699 11.02 16.2399 11.08 16.1199C11.13 15.9999 11.2 15.8899 11.29 15.7899C11.52 15.5599 11.87 15.4499 12.19 15.5199C12.26 15.5299 12.32 15.5499 12.38 15.5799C12.44 15.5999 12.5 15.6299 12.56 15.6699C12.61 15.6999 12.66 15.7499 12.71 15.7899C12.8 15.8899 12.87 15.9999 12.92 16.1199C12.97 16.2399 13 16.3699 13 16.4999C13 16.7699 12.89 17.0199 12.71 17.2099C12.66 17.2499 12.61 17.2899 12.56 17.3299C12.5 17.3699 12.44 17.3999 12.38 17.4199C12.32 17.4499 12.26 17.4699 12.19 17.4799C12.13 17.4899 12.06 17.4999 12 17.4999Z"
        fill="#707581"
      />
      <path
        d="M16 17.4999C15.73 17.4999 15.48 17.3899 15.29 17.2099C15.2 17.1099 15.13 16.9999 15.08 16.8799C15.03 16.7599 15 16.6299 15 16.4999C15 16.2399 15.11 15.9799 15.29 15.7899C15.34 15.7499 15.39 15.7099 15.44 15.6699C15.5 15.6299 15.56 15.5999 15.62 15.5799C15.68 15.5499 15.74 15.5299 15.8 15.5199C16.13 15.4499 16.47 15.5599 16.71 15.7899C16.89 15.9799 17 16.2299 17 16.4999C17 16.6299 16.97 16.7599 16.92 16.8799C16.87 17.0099 16.8 17.1099 16.71 17.2099C16.52 17.3899 16.26 17.4999 16 17.4999Z"
        fill="#707581"
      />
    </svg>
  );
}

export function TermsandCondition() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 23.25H8C4.35 23.25 2.25 21.15 2.25 17.5V7.5C2.25 3.85 4.35 1.75 8 1.75H16C19.65 1.75 21.75 3.85 21.75 7.5V17.5C21.75 21.15 19.65 23.25 16 23.25ZM8 3.25C5.14 3.25 3.75 4.64 3.75 7.5V17.5C3.75 20.36 5.14 21.75 8 21.75H16C18.86 21.75 20.25 20.36 20.25 17.5V7.5C20.25 4.64 18.86 3.25 16 3.25H8Z"
        fill="#707581"
      />
      <path
        d="M18.5 9.75H16.5C14.98 9.75 13.75 8.52 13.75 7V5C13.75 4.59 14.09 4.25 14.5 4.25C14.91 4.25 15.25 4.59 15.25 5V7C15.25 7.69 15.81 8.25 16.5 8.25H18.5C18.91 8.25 19.25 8.59 19.25 9C19.25 9.41 18.91 9.75 18.5 9.75Z"
        fill="#707581"
      />
      <path
        d="M12 14.25H8C7.59 14.25 7.25 13.91 7.25 13.5C7.25 13.09 7.59 12.75 8 12.75H12C12.41 12.75 12.75 13.09 12.75 13.5C12.75 13.91 12.41 14.25 12 14.25Z"
        fill="#707581"
      />
      <path
        d="M16 18.25H8C7.59 18.25 7.25 17.91 7.25 17.5C7.25 17.09 7.59 16.75 8 16.75H16C16.41 16.75 16.75 17.09 16.75 17.5C16.75 17.91 16.41 18.25 16 18.25Z"
        fill="#707581"
      />
    </svg>
  );
}

export function PrivactPolicy() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 23.2604C10.91 23.2604 9.82999 22.9404 8.97999 22.3104L4.67999 19.1004C3.53999 18.2504 2.64999 16.4704 2.64999 15.0604V7.62043C2.64999 6.08043 3.77999 4.44043 5.22999 3.90043L10.22 2.03043C11.21 1.66043 12.77 1.66043 13.76 2.03043L18.75 3.90043C20.2 4.44043 21.33 6.08043 21.33 7.62043V15.0504C21.33 16.4704 20.44 18.2404 19.3 19.0904L15 22.3004C14.17 22.9404 13.09 23.2604 12 23.2604ZM10.75 3.44043L5.75999 5.31043C4.90999 5.63043 4.15999 6.71043 4.15999 7.63043V15.0604C4.15999 16.0104 4.82999 17.3404 5.57999 17.9004L9.87999 21.1104C11.03 21.9704 12.97 21.9704 14.13 21.1104L18.43 17.9004C19.19 17.3304 19.85 16.0104 19.85 15.0604V7.62043C19.85 6.71043 19.1 5.63043 18.25 5.30043L13.26 3.43043C12.58 3.19043 11.42 3.19043 10.75 3.44043Z"
        fill="#707581"
      />
      <path
        d="M10.66 14.7301C10.47 14.7301 10.28 14.6601 10.13 14.5101L8.51999 12.9001C8.22999 12.6101 8.22999 12.1301 8.51999 11.8401C8.80999 11.5501 9.28999 11.5501 9.57999 11.8401L10.66 12.9201L14.43 9.15012C14.72 8.86012 15.2 8.86012 15.49 9.15012C15.78 9.44012 15.78 9.92012 15.49 10.2101L11.19 14.5101C11.04 14.6601 10.85 14.7301 10.66 14.7301Z"
        fill="#707581"
      />
    </svg>
  );
}

export function ContactUs() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 23.25H3C2.04 23.25 1.25 22.46 1.25 21.5V8.5C1.25 4.08 3.58 1.75 8 1.75H16C20.42 1.75 22.75 4.08 22.75 8.5V16.5C22.75 20.92 20.42 23.25 16 23.25ZM8 3.25C4.42 3.25 2.75 4.92 2.75 8.5V21.5C2.75 21.64 2.86 21.75 3 21.75H16C19.58 21.75 21.25 20.08 21.25 16.5V8.5C21.25 4.92 19.58 3.25 16 3.25H8Z"
        fill="#707581"
      />
      <path
        d="M17 10.75H7C6.59 10.75 6.25 10.41 6.25 10C6.25 9.59 6.59 9.25 7 9.25H17C17.41 9.25 17.75 9.59 17.75 10C17.75 10.41 17.41 10.75 17 10.75Z"
        fill="#707581"
      />
      <path
        d="M14 15.75H7C6.59 15.75 6.25 15.41 6.25 15C6.25 14.59 6.59 14.25 7 14.25H14C14.41 14.25 14.75 14.59 14.75 15C14.75 15.41 14.41 15.75 14 15.75Z"
        fill="#707581"
      />
    </svg>
  );
}

export function DeleteAccount() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 7.23046C20.98 7.23046 20.95 7.23046 20.92 7.23046C15.63 6.70046 10.35 6.50046 5.12001 7.03046L3.08001 7.23046C2.66001 7.27046 2.29001 6.97046 2.25001 6.55046C2.21001 6.13046 2.51001 5.77046 2.92001 5.73046L4.96001 5.53046C10.28 4.99046 15.67 5.20046 21.07 5.73046C21.48 5.77046 21.78 6.14046 21.74 6.55046C21.71 6.94046 21.38 7.23046 21 7.23046Z"
        fill="#707581"
      />
      <path
        d="M8.50001 6.22C8.46001 6.22 8.42001 6.22 8.37001 6.21C7.97001 6.14 7.69001 5.75 7.76001 5.35L7.98001 4.04C8.14001 3.08 8.36001 1.75 10.69 1.75H13.31C15.65 1.75 15.87 3.13 16.02 4.05L16.24 5.35C16.31 5.76 16.03 6.15 15.63 6.21C15.22 6.28 14.83 6 14.77 5.6L14.55 4.3C14.41 3.43 14.38 3.26 13.32 3.26H10.7C9.64001 3.26 9.62001 3.4 9.47001 4.29L9.24001 5.59C9.18001 5.96 8.86001 6.22 8.50001 6.22Z"
        fill="#707581"
      />
      <path
        d="M15.21 23.2496H8.78999C5.29999 23.2496 5.15999 21.3196 5.04999 19.7596L4.39999 9.68959C4.36999 9.27959 4.68999 8.91959 5.09999 8.88959C5.51999 8.86959 5.86999 9.17959 5.89999 9.58959L6.54999 19.6596C6.65999 21.1796 6.69999 21.7496 8.78999 21.7496H15.21C17.31 21.7496 17.35 21.1796 17.45 19.6596L18.1 9.58959C18.13 9.17959 18.49 8.86959 18.9 8.88959C19.31 8.91959 19.63 9.26959 19.6 9.68959L18.95 19.7596C18.84 21.3196 18.7 23.2496 15.21 23.2496Z"
        fill="#707581"
      />
      <path
        d="M13.66 17.75H10.33C9.91999 17.75 9.57999 17.41 9.57999 17C9.57999 16.59 9.91999 16.25 10.33 16.25H13.66C14.07 16.25 14.41 16.59 14.41 17C14.41 17.41 14.07 17.75 13.66 17.75Z"
        fill="#707581"
      />
      <path
        d="M14.5 13.75H9.5C9.09 13.75 8.75 13.41 8.75 13C8.75 12.59 9.09 12.25 9.5 12.25H14.5C14.91 12.25 15.25 12.59 15.25 13C15.25 13.41 14.91 13.75 14.5 13.75Z"
        fill="#707581"
      />
    </svg>
  );
}

export function SettingsNotification() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.70247 8.38659C6.05901 5.17767 8.77137 2.75 12 2.75C15.2287 2.75 17.9411 5.17767 18.2976 8.3866L18.5494 10.6528L18.5556 10.7078C18.6724 11.7261 19.0039 12.7081 19.5281 13.5889L19.5565 13.6364L20.1345 14.5998L20.154 14.6322C20.3996 15.0416 20.6127 15.3966 20.753 15.6945C20.8951 15.9962 21.0267 16.3655 20.9625 16.7727C20.8965 17.1906 20.6815 17.5704 20.3571 17.8419C20.041 18.1066 19.6565 18.1837 19.3247 18.2171C18.9971 18.25 18.583 18.25 18.1056 18.25L18.0678 18.25H5.93227L5.89452 18.25C5.41705 18.25 5.00296 18.25 4.67538 18.2171C4.34353 18.1837 3.95911 18.1066 3.64298 17.8419C3.3186 17.5704 3.10354 17.1906 3.03761 16.7727C2.97336 16.3655 3.10499 15.9962 3.2471 15.6945C3.38737 15.3966 3.60044 15.0416 3.84611 14.6321L3.86554 14.5998L4.44357 13.6364L4.47198 13.5889C4.99619 12.7081 5.32765 11.7261 5.44451 10.7078L5.45066 10.6528L5.70247 8.38659ZM12 4.25C9.53569 4.25 7.46543 6.10297 7.19329 8.55224L6.94149 10.8185L6.93473 10.8788C6.7937 12.1078 6.39365 13.293 5.76098 14.3561L5.72981 14.4081L5.15178 15.3715C4.88108 15.8227 4.70829 16.1124 4.60413 16.3336C4.54015 16.4694 4.52527 16.5337 4.52185 16.5527C4.53257 16.6024 4.55819 16.6477 4.59528 16.6824C4.61333 16.6893 4.67612 16.7096 4.82553 16.7246C5.06876 16.7491 5.40613 16.75 5.93227 16.75H18.0678C18.5939 16.75 18.9313 16.7491 19.1745 16.7246C19.324 16.7096 19.3868 16.6893 19.4048 16.6824C19.4419 16.6477 19.4675 16.6024 19.4782 16.5527C19.4748 16.5337 19.4599 16.4694 19.3959 16.3336C19.2918 16.1124 19.119 15.8227 18.8483 15.3715L18.2703 14.4081L18.2391 14.3561C17.6064 13.293 17.2064 12.1078 17.0653 10.8788L17.0586 10.8185L16.8068 8.55224C16.5346 6.10297 14.4644 4.25 12 4.25Z"
        fill="#707581"
      />
      <path
        d="M9.10222 18.1647C9.27315 19.1215 9.64978 19.967 10.1737 20.5701C10.6976 21.1731 11.3396 21.5 12 21.5C12.6604 21.5 13.3024 21.1731 13.8263 20.5701C14.3502 19.967 14.7269 19.1215 14.8978 18.1647"
        stroke="#707581"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
}

export function PasswordEye() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9999 16.8299C9.60992 16.8299 7.66992 14.8899 7.66992 12.4999C7.66992 10.1099 9.60992 8.16992 11.9999 8.16992C14.3899 8.16992 16.3299 10.1099 16.3299 12.4999C16.3299 14.8899 14.3899 16.8299 11.9999 16.8299ZM11.9999 9.66992C10.4399 9.66992 9.16992 10.9399 9.16992 12.4999C9.16992 14.0599 10.4399 15.3299 11.9999 15.3299C13.5599 15.3299 14.8299 14.0599 14.8299 12.4999C14.8299 10.9399 13.5599 9.66992 11.9999 9.66992Z"
        fill="#707581"
      />
      <path
        d="M12.0001 21.5205C8.24008 21.5205 4.69008 19.3205 2.25008 15.5005C1.19008 13.8505 1.19008 11.1605 2.25008 9.50047C4.70008 5.68047 8.25008 3.48047 12.0001 3.48047C15.7501 3.48047 19.3001 5.68047 21.7401 9.50047C22.8001 11.1505 22.8001 13.8405 21.7401 15.5005C19.3001 19.3205 15.7501 21.5205 12.0001 21.5205ZM12.0001 4.98047C8.77008 4.98047 5.68008 6.92047 3.52008 10.3105C2.77008 11.4805 2.77008 13.5205 3.52008 14.6905C5.68008 18.0805 8.77008 20.0205 12.0001 20.0205C15.2301 20.0205 18.3201 18.0805 20.4801 14.6905C21.2301 13.5205 21.2301 11.4805 20.4801 10.3105C18.3201 6.92047 15.2301 4.98047 12.0001 4.98047Z"
        fill="#707581"
      />
    </svg>
  );
}

export function CrossIcon() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="24"
        height="23.7126"
        transform="translate(0 0.880249)"
        fill="#F3F3F3"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.0457 5.0761C19.603 4.66218 18.9104 4.66143 18.4669 5.0744L12.5 10.6299L6.53315 5.07441C6.08961 4.66144 5.39697 4.66218 4.95433 5.0761L4.89889 5.12795C4.41897 5.57674 4.4198 6.33192 4.90071 6.77968L10.768 12.2425L4.90071 17.7053C4.4198 18.1531 4.41897 18.9083 4.8989 19.3571L4.95434 19.4089C5.39697 19.8228 6.08961 19.8236 6.53315 19.4106L12.5 13.8551L18.4668 19.4106C18.9104 19.8236 19.603 19.8228 20.0457 19.4089L20.1011 19.3571C20.581 18.9083 20.5802 18.1531 20.0993 17.7053L14.232 12.2425L20.0993 6.77968C20.5802 6.33192 20.581 5.57674 20.1011 5.12794L20.0457 5.0761Z"
        fill="#5C5C5C"
      />
    </svg>
  );
}

export function ProfileRightArrow() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0316 16.4673C9.73741 16.7589 9.7353 17.2338 10.0269 17.528C10.3185 17.8222 10.7933 17.8243 11.0875 17.5327L12.8823 15.7539C13.5582 15.084 14.1107 14.5364 14.5025 14.0485C14.9099 13.5412 15.2049 13.0263 15.2837 12.4082C15.3182 12.1371 15.3182 11.8629 15.2837 11.5918C15.2049 10.9737 14.9099 10.4588 14.5025 9.95146C14.1107 9.46359 13.5582 8.91605 12.8823 8.24611L11.0875 6.46731C10.7933 6.17573 10.3185 6.17784 10.0269 6.47204C9.7353 6.76624 9.73741 7.24111 10.0316 7.53269L11.7946 9.28C12.5101 9.98914 13.0009 10.4772 13.333 10.8907C13.6556 11.2924 13.7662 11.5504 13.7957 11.7815C13.8142 11.9266 13.8142 12.0734 13.7957 12.2185C13.7662 12.4496 13.6556 12.7076 13.333 13.1093C13.0009 13.5228 12.5101 14.0109 11.7946 14.72L10.0316 16.4673Z"
        fill="#707581"
      />
    </svg>
  );
}

export function AddProductBtn() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 6.5L12 18.5" stroke="#DBBB51" stroke-linecap="round" />
      <path d="M18 12.5L6 12.5" stroke="#DBBB51" stroke-linecap="round" />
    </svg>
  );
}

export function ProductRatingStar() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.58939 6.01655C9.12445 4.68265 9.39198 4.01569 9.82663 3.92326C9.94092 3.89895 10.059 3.89895 10.1733 3.92326C10.608 4.01569 10.8755 4.68265 11.4106 6.01655C11.7148 6.77512 11.867 7.1544 12.1517 7.41238C12.2315 7.48473 12.3182 7.54918 12.4105 7.6048C12.7395 7.80312 13.1503 7.8399 13.9717 7.91347C15.3624 8.03801 16.0577 8.10029 16.27 8.49674C16.314 8.57885 16.3439 8.66775 16.3585 8.75974C16.4289 9.20393 15.9177 9.66898 14.8954 10.5991L14.6115 10.8574C14.1335 11.2922 13.8946 11.5096 13.7563 11.781C13.6734 11.9437 13.6178 12.119 13.5918 12.2998C13.5483 12.6012 13.6183 12.9166 13.7583 13.5475L13.8083 13.7728C14.0593 14.9041 14.1848 15.4698 14.0281 15.7478C13.8874 15.9975 13.6282 16.1574 13.3419 16.1711C13.0231 16.1863 12.5739 15.8203 11.6756 15.0883C11.0838 14.6061 10.7879 14.3649 10.4594 14.2707C10.1592 14.1846 9.8408 14.1846 9.5406 14.2707C9.21209 14.3649 8.91617 14.6061 8.32433 15.0883C7.42601 15.8203 6.97686 16.1863 6.65809 16.1711C6.37176 16.1574 6.11255 15.9975 5.97183 15.7478C5.81517 15.4698 5.94067 14.9041 6.19167 13.7728L6.24167 13.5475C6.38163 12.9166 6.45161 12.6012 6.40819 12.2998C6.38214 12.119 6.32654 11.9437 6.24362 11.781C6.10539 11.5096 5.86642 11.2922 5.38846 10.8574L5.10457 10.5991C4.08224 9.66898 3.57108 9.20393 3.64148 8.75974C3.65606 8.66775 3.68596 8.57885 3.72993 8.49674C3.94226 8.10029 4.63758 8.03801 6.02822 7.91347C6.8497 7.8399 7.26045 7.80312 7.58948 7.6048C7.68177 7.54918 7.76845 7.48473 7.8483 7.41238C8.13297 7.1544 8.28511 6.77512 8.58939 6.01655Z"
        fill="#DBBB51"
        stroke="#DBBB51"
      />
    </svg>
  );
}

export function StarProductRating() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.58939 6.01655C9.12445 4.68265 9.39198 4.01569 9.82663 3.92326C9.94092 3.89895 10.059 3.89895 10.1733 3.92326C10.608 4.01569 10.8755 4.68265 11.4106 6.01655C11.7148 6.77512 11.867 7.1544 12.1517 7.41238C12.2315 7.48473 12.3182 7.54918 12.4105 7.6048C12.7395 7.80312 13.1503 7.8399 13.9717 7.91347C15.3624 8.03801 16.0577 8.10029 16.27 8.49674C16.314 8.57885 16.3439 8.66775 16.3585 8.75974C16.4289 9.20393 15.9177 9.66898 14.8954 10.5991L14.6115 10.8574C14.1335 11.2922 13.8946 11.5096 13.7563 11.781C13.6734 11.9437 13.6178 12.119 13.5918 12.2998C13.5483 12.6012 13.6183 12.9166 13.7583 13.5475L13.8083 13.7728C14.0593 14.9041 14.1848 15.4698 14.0281 15.7478C13.8874 15.9975 13.6282 16.1574 13.3419 16.1711C13.0231 16.1863 12.5739 15.8203 11.6756 15.0883C11.0838 14.6061 10.7879 14.3649 10.4594 14.2707C10.1592 14.1846 9.8408 14.1846 9.5406 14.2707C9.21209 14.3649 8.91617 14.6061 8.32433 15.0883C7.42601 15.8203 6.97686 16.1863 6.65809 16.1711C6.37176 16.1574 6.11255 15.9975 5.97183 15.7478C5.81517 15.4698 5.94067 14.9041 6.19167 13.7728L6.24167 13.5475C6.38163 12.9166 6.45161 12.6012 6.40819 12.2998C6.38214 12.119 6.32654 11.9437 6.24362 11.781C6.10539 11.5096 5.86642 11.2922 5.38846 10.8574L5.10457 10.5991C4.08224 9.66898 3.57108 9.20393 3.64148 8.75974C3.65606 8.66775 3.68596 8.57885 3.72993 8.49674C3.94226 8.10029 4.63758 8.03801 6.02822 7.91347C6.8497 7.8399 7.26045 7.80312 7.58948 7.6048C7.68177 7.54918 7.76845 7.48473 7.8483 7.41238C8.13297 7.1544 8.28511 6.77512 8.58939 6.01655Z"
        fill="#DBBB51"
        stroke="#DBBB51"
      />
    </svg>
  );
}

export function DeleteIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9999 6.72998C20.9799 6.72998 20.9499 6.72998 20.9199 6.72998C15.6299 6.19998 10.3499 5.99998 5.11992 6.52998L3.07992 6.72998C2.65992 6.76998 2.28992 6.46998 2.24992 6.04998C2.20992 5.62998 2.50992 5.26998 2.91992 5.22998L4.95992 5.02998C10.2799 4.48998 15.6699 4.69998 21.0699 5.22998C21.4799 5.26998 21.7799 5.63998 21.7399 6.04998C21.7099 6.43998 21.3799 6.72998 20.9999 6.72998Z"
        fill="black"
      />
      <path
        d="M8.50001 5.72C8.46001 5.72 8.42001 5.72 8.37001 5.71C7.97001 5.64 7.69001 5.25 7.76001 4.85L7.98001 3.54C8.14001 2.58 8.36001 1.25 10.69 1.25H13.31C15.65 1.25 15.87 2.63 16.02 3.55L16.24 4.85C16.31 5.26 16.03 5.65 15.63 5.71C15.22 5.78 14.83 5.5 14.77 5.1L14.55 3.8C14.41 2.93 14.38 2.76 13.32 2.76H10.7C9.64001 2.76 9.62001 2.9 9.47001 3.79L9.24001 5.09C9.18001 5.46 8.86001 5.72 8.50001 5.72Z"
        fill="black"
      />
      <path
        d="M15.2099 22.7501H8.7899C5.2999 22.7501 5.1599 20.8201 5.0499 19.2601L4.3999 9.19007C4.3699 8.78007 4.6899 8.42008 5.0999 8.39008C5.5199 8.37008 5.8699 8.68008 5.8999 9.09008L6.5499 19.1601C6.6599 20.6801 6.6999 21.2501 8.7899 21.2501H15.2099C17.3099 21.2501 17.3499 20.6801 17.4499 19.1601L18.0999 9.09008C18.1299 8.68008 18.4899 8.37008 18.8999 8.39008C19.3099 8.42008 19.6299 8.77007 19.5999 9.19007L18.9499 19.2601C18.8399 20.8201 18.6999 22.7501 15.2099 22.7501Z"
        fill="black"
      />
      <path
        d="M13.6601 17.25H10.3301C9.92008 17.25 9.58008 16.91 9.58008 16.5C9.58008 16.09 9.92008 15.75 10.3301 15.75H13.6601C14.0701 15.75 14.4101 16.09 14.4101 16.5C14.4101 16.91 14.0701 17.25 13.6601 17.25Z"
        fill="black"
      />
      <path
        d="M14.5 13.25H9.5C9.09 13.25 8.75 12.91 8.75 12.5C8.75 12.09 9.09 11.75 9.5 11.75H14.5C14.91 11.75 15.25 12.09 15.25 12.5C15.25 12.91 14.91 13.25 14.5 13.25Z"
        fill="black"
      />
    </svg>
  );
}

export function UserIcon() {
  return (
    <svg
      width="4"
      height="14"
      viewBox="0 0 4 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="1.55556" cy="6.99989" r="1.55556" fill="#707581" />
      <circle cx="1.55556" cy="1.55556" r="1.55556" fill="#707581" />
      <circle cx="1.55556" cy="12.4442" r="1.55556" fill="#707581" />
    </svg>
  );
}

export function CategoryCrossIcon() {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.954915 2.56107C0 3.8754 0 5.75027 0 9.5C0 13.2497 0 15.1246 0.954915 16.4389C1.26331 16.8634 1.6366 17.2367 2.06107 17.5451C3.3754 18.5 5.25027 18.5 9 18.5C12.7497 18.5 14.6246 18.5 15.9389 17.5451C16.3634 17.2367 16.7367 16.8634 17.0451 16.4389C18 15.1246 18 13.2497 18 9.5C18 5.75027 18 3.8754 17.0451 2.56107C16.7367 2.1366 16.3634 1.76331 15.9389 1.45491C14.6246 0.5 12.7497 0.5 9 0.5C5.25027 0.5 3.3754 0.5 2.06107 1.45491C1.6366 1.76331 1.26331 2.1366 0.954915 2.56107ZM7.40899 7.09099C7.1161 6.7981 6.64123 6.7981 6.34833 7.09099C6.05544 7.38389 6.05544 7.85876 6.34833 8.15165L7.93932 9.74264L6.34833 11.3336C6.05544 11.6265 6.05544 12.1014 6.34833 12.3943C6.64123 12.6872 7.1161 12.6872 7.40899 12.3943L8.99998 10.8033L10.591 12.3943C10.8839 12.6872 11.3587 12.6872 11.6516 12.3943C11.9445 12.1014 11.9445 11.6265 11.6516 11.3336L10.0606 9.74264L11.6516 8.15165C11.9445 7.85876 11.9445 7.38389 11.6516 7.09099C11.3587 6.7981 10.8839 6.7981 10.591 7.09099L8.99998 8.68198L7.40899 7.09099Z"
        fill="#77778D"
      />
    </svg>
  );
}

export function GridViewIcon() {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.16536 7.16732H3.83203C2.2187 7.16732 1.33203 6.28065 1.33203 4.66732V3.33398C1.33203 1.72065 2.2187 0.833984 3.83203 0.833984H5.16536C6.7787 0.833984 7.66536 1.72065 7.66536 3.33398V4.66732C7.66536 6.28065 6.7787 7.16732 5.16536 7.16732ZM3.83203 1.83398C2.7787 1.83398 2.33203 2.28065 2.33203 3.33398V4.66732C2.33203 5.72065 2.7787 6.16732 3.83203 6.16732H5.16536C6.2187 6.16732 6.66536 5.72065 6.66536 4.66732V3.33398C6.66536 2.28065 6.2187 1.83398 5.16536 1.83398H3.83203Z"
        fill="#1E1D1C"
      />
      <path
        d="M13.1654 7.16732H11.832C10.2187 7.16732 9.33203 6.28065 9.33203 4.66732V3.33398C9.33203 1.72065 10.2187 0.833984 11.832 0.833984H13.1654C14.7787 0.833984 15.6654 1.72065 15.6654 3.33398V4.66732C15.6654 6.28065 14.7787 7.16732 13.1654 7.16732ZM11.832 1.83398C10.7787 1.83398 10.332 2.28065 10.332 3.33398V4.66732C10.332 5.72065 10.7787 6.16732 11.832 6.16732H13.1654C14.2187 6.16732 14.6654 5.72065 14.6654 4.66732V3.33398C14.6654 2.28065 14.2187 1.83398 13.1654 1.83398H11.832Z"
        fill="#1E1D1C"
      />
      <path
        d="M13.1654 15.1673H11.832C10.2187 15.1673 9.33203 14.2807 9.33203 12.6673V11.334C9.33203 9.72065 10.2187 8.83398 11.832 8.83398H13.1654C14.7787 8.83398 15.6654 9.72065 15.6654 11.334V12.6673C15.6654 14.2807 14.7787 15.1673 13.1654 15.1673ZM11.832 9.83398C10.7787 9.83398 10.332 10.2807 10.332 11.334V12.6673C10.332 13.7207 10.7787 14.1673 11.832 14.1673H13.1654C14.2187 14.1673 14.6654 13.7207 14.6654 12.6673V11.334C14.6654 10.2807 14.2187 9.83398 13.1654 9.83398H11.832Z"
        fill="#1E1D1C"
      />
      <path
        d="M5.16536 15.1673H3.83203C2.2187 15.1673 1.33203 14.2807 1.33203 12.6673V11.334C1.33203 9.72065 2.2187 8.83398 3.83203 8.83398H5.16536C6.7787 8.83398 7.66536 9.72065 7.66536 11.334V12.6673C7.66536 14.2807 6.7787 15.1673 5.16536 15.1673ZM3.83203 9.83398C2.7787 9.83398 2.33203 10.2807 2.33203 11.334V12.6673C2.33203 13.7207 2.7787 14.1673 3.83203 14.1673H5.16536C6.2187 14.1673 6.66536 13.7207 6.66536 12.6673V11.334C6.66536 10.2807 6.2187 9.83398 5.16536 9.83398H3.83203Z"
        fill="#1E1D1C"
      />
    </svg>
  );
}

export function ListViewIcon() {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7654 15.1667H3.23203C1.95203 15.1667 1.33203 14.5133 1.33203 13.18V10.4867C1.33203 9.14667 1.95203 8.5 3.23203 8.5H13.7654C15.0454 8.5 15.6654 9.15333 15.6654 10.4867V13.18C15.6654 14.5133 15.0454 15.1667 13.7654 15.1667ZM3.23203 9.5C2.5587 9.5 2.33203 9.64 2.33203 10.4867V13.18C2.33203 14.0267 2.5587 14.1667 3.23203 14.1667H13.7654C14.4387 14.1667 14.6654 14.0267 14.6654 13.18V10.4867C14.6654 9.64 14.4387 9.5 13.7654 9.5H3.23203Z"
        fill="#77778D"
      />
      <path
        d="M13.7654 7.50065H3.23203C1.95203 7.50065 1.33203 6.84732 1.33203 5.51398V2.82065C1.33203 1.48065 1.95203 0.833984 3.23203 0.833984H13.7654C15.0454 0.833984 15.6654 1.48732 15.6654 2.82065V5.51398C15.6654 6.84732 15.0454 7.50065 13.7654 7.50065ZM3.23203 1.83398C2.5587 1.83398 2.33203 1.97398 2.33203 2.82065V5.51398C2.33203 6.36065 2.5587 6.50065 3.23203 6.50065H13.7654C14.4387 6.50065 14.6654 6.36065 14.6654 5.51398V2.82065C14.6654 1.97398 14.4387 1.83398 13.7654 1.83398H3.23203Z"
        fill="#77778D"
      />
    </svg>
  );
}

export function FilterIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 2.25C4.48122 2.25 3.25 3.48122 3.25 5C3.25 6.51878 4.48122 7.75 6 7.75C7.51878 7.75 8.75 6.51878 8.75 5C8.75 3.48122 7.51878 2.25 6 2.25ZM4.75 5C4.75 4.30964 5.30964 3.75 6 3.75C6.69036 3.75 7.25 4.30964 7.25 5C7.25 5.69036 6.69036 6.25 6 6.25C5.30964 6.25 4.75 5.69036 4.75 5Z"
        fill="#2D264B"
      />
      <path
        d="M12 4.25C11.5858 4.25 11.25 4.58579 11.25 5C11.25 5.41421 11.5858 5.75 12 5.75L20 5.75C20.4142 5.75 20.75 5.41421 20.75 5C20.75 4.58579 20.4142 4.25 20 4.25L12 4.25Z"
        fill="#2D264B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18 9.25C16.4812 9.25 15.25 10.4812 15.25 12C15.25 13.5188 16.4812 14.75 18 14.75C19.5188 14.75 20.75 13.5188 20.75 12C20.75 10.4812 19.5188 9.25 18 9.25ZM16.75 12C16.75 11.3096 17.3096 10.75 18 10.75C18.6904 10.75 19.25 11.3096 19.25 12C19.25 12.6904 18.6904 13.25 18 13.25C17.3096 13.25 16.75 12.6904 16.75 12Z"
        fill="#2D264B"
      />
      <path
        d="M4 11.25C3.58579 11.25 3.25 11.5858 3.25 12C3.25 12.4142 3.58579 12.75 4 12.75L12 12.75C12.4142 12.75 12.75 12.4142 12.75 12C12.75 11.5858 12.4142 11.25 12 11.25L4 11.25Z"
        fill="#2D264B"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 16.25C4.48122 16.25 3.25 17.4812 3.25 19C3.25 20.5188 4.48122 21.75 6 21.75C7.51878 21.75 8.75 20.5188 8.75 19C8.75 17.4812 7.51878 16.25 6 16.25ZM4.75 19C4.75 18.3096 5.30964 17.75 6 17.75C6.69036 17.75 7.25 18.3096 7.25 19C7.25 19.6904 6.69036 20.25 6 20.25C5.30964 20.25 4.75 19.6904 4.75 19Z"
        fill="#2D264B"
      />
      <path
        d="M12 18.25C11.5858 18.25 11.25 18.5858 11.25 19C11.25 19.4142 11.5858 19.75 12 19.75H20C20.4142 19.75 20.75 19.4142 20.75 19C20.75 18.5858 20.4142 18.25 20 18.25H12Z"
        fill="#2D264B"
      />
    </svg>
  );
}

export function InStockIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.5 21V16C14.5 15.4477 14.0523 15 13.5 15H10.5C9.94772 15 9.5 15.4477 9.5 16V21"
        stroke="#069952"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 11V17C5 18.8856 5 19.8284 5.58579 20.4142C6.17157 21 7.11438 21 9 21H15C16.8856 21 17.8284 21 18.4142 20.4142C19 19.8284 19 18.8856 19 17V11"
        stroke="#069952"
      />
      <path
        d="M4.62127 4.51493C4.80316 3.78737 4.8941 3.42359 5.16536 3.21179C5.43663 3 5.8116 3 6.56155 3H17.4384C18.1884 3 18.5634 3 18.8346 3.21179C19.1059 3.42359 19.1968 3.78737 19.3787 4.51493L20.5823 9.32938C20.6792 9.71675 20.7276 9.91044 20.7169 10.0678C20.6892 10.4757 20.416 10.8257 20.0269 10.9515C19.8769 11 19.6726 11 19.2641 11V11C18.7309 11 18.4644 11 18.2405 10.9478C17.6133 10.8017 17.0948 10.3625 16.8475 9.76781C16.7593 9.55555 16.7164 9.29856 16.6308 8.78457V8.78457C16.6068 8.64076 16.5948 8.56886 16.5812 8.54994C16.5413 8.49439 16.4587 8.49439 16.4188 8.54994C16.4052 8.56886 16.3932 8.64076 16.3692 8.78457L16.2877 9.27381C16.2791 9.32568 16.2747 9.35161 16.2704 9.37433C16.0939 10.3005 15.2946 10.9777 14.352 10.9995C14.3289 11 14.3026 11 14.25 11V11C14.1974 11 14.1711 11 14.148 10.9995C13.2054 10.9777 12.4061 10.3005 12.2296 9.37433C12.2253 9.35161 12.2209 9.32568 12.2123 9.27381L12.1308 8.78457C12.1068 8.64076 12.0948 8.56886 12.0812 8.54994C12.0413 8.49439 11.9587 8.49439 11.9188 8.54994C11.9052 8.56886 11.8932 8.64076 11.8692 8.78457L11.7877 9.27381C11.7791 9.32568 11.7747 9.35161 11.7704 9.37433C11.5939 10.3005 10.7946 10.9777 9.85199 10.9995C9.82887 11 9.80258 11 9.75 11V11C9.69742 11 9.67113 11 9.64801 10.9995C8.70541 10.9777 7.90606 10.3005 7.7296 9.37433C7.72527 9.35161 7.72095 9.32568 7.7123 9.27381L7.63076 8.78457C7.60679 8.64076 7.59481 8.56886 7.58122 8.54994C7.54132 8.49439 7.45868 8.49439 7.41878 8.54994C7.40519 8.56886 7.39321 8.64076 7.36924 8.78457V8.78457C7.28357 9.29856 7.24074 9.55555 7.15249 9.76781C6.90524 10.3625 6.38675 10.8017 5.75951 10.9478C5.53563 11 5.26905 11 4.73591 11V11C4.32737 11 4.12309 11 3.97306 10.9515C3.58403 10.8257 3.31078 10.4757 3.28307 10.0678C3.27239 9.91044 3.32081 9.71675 3.41765 9.32938L4.62127 4.51493Z"
        stroke="#069952"
      />
    </svg>
  );
}

export function WishlistIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33399 5.85115C3.47185 5.40409 3.7188 4.98402 4.09749 4.60856C4.39566 4.31294 4.70511 4.11799 5.01559 4M9.06777 2.76395C10.1835 2.05617 11.9855 1.38688 13.5416 2.97381C17.2356 6.74091 10.9008 14 8.00066 14C5.10057 14 -1.23434 6.74091 2.45967 2.97381C4.01579 1.3869 5.81774 2.05618 6.93351 2.76395C7.56397 3.16388 8.43731 3.16388 9.06777 2.76395Z"
        stroke="#1E1D1C"
        stroke-linecap="round"
      />
    </svg>
  );
}

export function NegativeIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 12L6 12"
        stroke="#020203"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
}

export function PositiveIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 6L12 18"
        stroke="#020203"
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M18 12L6 12"
        stroke="#020203"
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
}

export function SeemoreArrow() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.01799 4.81089C6.82186 4.6165 6.50528 4.61791 6.31089 4.81404C6.1165 5.01017 6.11791 5.32675 6.31404 5.52114L7.48936 6.68601C7.96635 7.15877 8.29355 7.48413 8.51495 7.75982C8.73002 8.02762 8.8038 8.19963 8.82344 8.35368C8.83576 8.45041 8.83576 8.54829 8.82344 8.64502C8.8038 8.79907 8.73002 8.97108 8.51495 9.23888C8.29355 9.51456 7.96635 9.83992 7.48936 10.3127L6.31404 11.4776C6.11791 11.6719 6.1165 11.9885 6.31089 12.1847C6.50528 12.3808 6.82186 12.3822 7.01799 12.1878L8.21448 11.002C8.66512 10.5553 9.03344 10.1903 9.29465 9.86504C9.56626 9.52683 9.76289 9.18353 9.81541 8.77146C9.83844 8.59077 9.83844 8.40793 9.81541 8.22724C9.76289 7.81517 9.56626 7.47187 9.29464 7.13365C9.03344 6.80841 8.66512 6.44338 8.21447 5.99674L7.01799 4.81089Z"
        fill="#020203"
      />
    </svg>
  );
}

export function DeleteBin() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9997 6.73046C20.9797 6.73046 20.9497 6.73046 20.9197 6.73046C15.6297 6.20046 10.3497 6.00046 5.11967 6.53046L3.07967 6.73046C2.65967 6.77046 2.28967 6.47046 2.24967 6.05046C2.20967 5.63046 2.50967 5.27046 2.91967 5.23046L4.95967 5.03046C10.2797 4.49046 15.6697 4.70046 21.0697 5.23046C21.4797 5.27046 21.7797 5.64046 21.7397 6.05046C21.7097 6.44046 21.3797 6.73046 20.9997 6.73046Z"
        fill="#F66356"
      />
      <path
        d="M8.50074 5.72C8.46074 5.72 8.42074 5.72 8.37074 5.71C7.97074 5.64 7.69074 5.25 7.76074 4.85L7.98074 3.54C8.14074 2.58 8.36074 1.25 10.6907 1.25H13.3107C15.6507 1.25 15.8707 2.63 16.0207 3.55L16.2407 4.85C16.3107 5.26 16.0307 5.65 15.6307 5.71C15.2207 5.78 14.8307 5.5 14.7707 5.1L14.5507 3.8C14.4107 2.93 14.3807 2.76 13.3207 2.76H10.7007C9.64074 2.76 9.62074 2.9 9.47074 3.79L9.24074 5.09C9.18074 5.46 8.86074 5.72 8.50074 5.72Z"
        fill="#F66356"
      />
      <path
        d="M15.2104 22.7496H8.79039C5.30039 22.7496 5.16039 20.8196 5.05039 19.2596L4.40039 9.18959C4.37039 8.77959 4.69039 8.41959 5.10039 8.38959C5.52039 8.36959 5.87039 8.67959 5.90039 9.08959L6.55039 19.1596C6.66039 20.6796 6.70039 21.2496 8.79039 21.2496H15.2104C17.3104 21.2496 17.3504 20.6796 17.4504 19.1596L18.1004 9.08959C18.1304 8.67959 18.4904 8.36959 18.9004 8.38959C19.3104 8.41959 19.6304 8.76959 19.6004 9.18959L18.9504 19.2596C18.8404 20.8196 18.7004 22.7496 15.2104 22.7496Z"
        fill="#F66356"
      />
      <path
        d="M13.6601 17.25H10.3301C9.92008 17.25 9.58008 16.91 9.58008 16.5C9.58008 16.09 9.92008 15.75 10.3301 15.75H13.6601C14.0701 15.75 14.4101 16.09 14.4101 16.5C14.4101 16.91 14.0701 17.25 13.6601 17.25Z"
        fill="#F66356"
      />
      <path
        d="M14.5 13.25H9.5C9.09 13.25 8.75 12.91 8.75 12.5C8.75 12.09 9.09 11.75 9.5 11.75H14.5C14.91 11.75 15.25 12.09 15.25 12.5C15.25 12.91 14.91 13.25 14.5 13.25Z"
        fill="#F66356"
      />
    </svg>
  );
}

export function AddNewCard() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 1L8 14"
        stroke="#707581"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 8L1 8"
        stroke="#707581"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function MegamenuRightIcon() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.01994 4.81121C6.82381 4.61683 6.50723 4.61824 6.31284 4.81437C6.11845 5.0105 6.11986 5.32708 6.316 5.52147L7.49131 6.68634C7.9683 7.1591 8.29551 7.48446 8.51691 7.76014C8.73197 8.02794 8.80575 8.19995 8.82539 8.354C8.83772 8.45074 8.83772 8.54861 8.82539 8.64534C8.80575 8.7994 8.73197 8.97141 8.51691 9.2392C8.29551 9.51489 7.96831 9.84025 7.49131 10.313L6.316 11.4779C6.11987 11.6723 6.11845 11.9888 6.31284 12.185C6.50723 12.3811 6.82381 12.3825 7.01994 12.1881L8.21643 11.0023C8.66708 10.5556 9.03539 10.1906 9.2966 9.86537C9.56822 9.52715 9.76484 9.18386 9.81736 8.77178C9.84039 8.5911 9.84039 8.40825 9.81736 8.22757C9.76484 7.81549 9.56822 7.4722 9.2966 7.13398C9.03539 6.80873 8.66708 6.4437 8.21643 5.99707L7.01994 4.81121Z"
        fill="#020203"
      />
    </svg>
  );
}

export function ChatMessageIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 12C4 7.58172 7.58172 4 12 4V4C16.4183 4 20 7.58172 20 12V17.0909C20 17.9375 20 18.3608 19.8739 18.6989C19.6712 19.2425 19.2425 19.6712 18.6989 19.8739C18.3608 20 17.9375 20 17.0909 20H12C7.58172 20 4 16.4183 4 12V12Z"
        stroke="#020203"
      />
      <path
        d="M9 11L15 11"
        stroke="#020203"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 15H15"
        stroke="#020203"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function NotificationBuyerIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.0976 2.87223C13.4415 2.6311 12.7341 2.5 11.9987 2.5C8.89741 2.5 6.29208 4.83189 5.9496 7.9142L5.69779 10.1804L5.69154 10.2363C5.57065 11.2897 5.22776 12.3056 4.68547 13.2168L4.6566 13.265L4.07857 14.2284L4.06464 14.2516C3.81421 14.669 3.60676 15.0147 3.47193 15.301C3.33584 15.5899 3.23095 15.9025 3.28322 16.2338C3.33973 16.5919 3.52406 16.9175 3.8021 17.1502C4.05928 17.3655 4.38126 17.4364 4.69906 17.4683C5.01393 17.5 5.41713 17.5 5.90385 17.5H5.93093H18.0665H18.0935C18.5803 17.5 18.9835 17.5 19.2983 17.4683C19.6161 17.4364 19.9381 17.3655 20.1953 17.1502C20.4733 16.9175 20.6577 16.5919 20.7142 16.2338C20.7664 15.9025 20.6616 15.5899 20.5255 15.301C20.3906 15.0147 20.1832 14.669 19.9328 14.2517L19.9328 14.2516L19.9188 14.2284L19.3408 13.265L19.3119 13.2168C18.8988 12.5226 18.6014 11.7677 18.4297 10.9817C18.2876 10.9938 18.1439 11 17.9987 11C17.7981 11 17.6003 10.9882 17.4058 10.9652C17.5905 11.9387 17.9442 12.874 18.4526 13.7282L18.4833 13.7795L19.0613 14.7429C19.3292 15.1894 19.51 15.4918 19.6208 15.7271C19.7328 15.9649 19.7307 16.0504 19.7264 16.0779C19.7076 16.1973 19.6461 16.3058 19.5534 16.3834C19.532 16.4013 19.4598 16.447 19.1982 16.4734C18.9395 16.4994 18.5871 16.5 18.0665 16.5H5.93093C5.41024 16.5 5.05789 16.4994 4.79916 16.4734C4.53755 16.447 4.46535 16.4013 4.44396 16.3834C4.35128 16.3058 4.28983 16.1973 4.271 16.0779C4.26665 16.0504 4.26458 15.9649 4.37662 15.7271C4.48741 15.4918 4.66817 15.1894 4.93606 14.7429L5.5141 13.7795L5.54481 13.7282C6.1594 12.6955 6.54802 11.5442 6.68502 10.3503L6.69168 10.2909L6.94348 8.02463C7.22969 5.44875 9.40696 3.5 11.9987 3.5C12.534 3.5 13.0516 3.58314 13.5385 3.73776C13.6952 3.42946 13.8829 3.13958 14.0976 2.87223ZM16.5852 4.58508C16.3315 4.83854 16.1455 5.15981 16.0568 5.51938C16.5388 6.1563 16.8754 6.91253 17.0145 7.74146C17.305 7.90605 17.6409 8 17.9987 8C18.0183 8 18.0378 7.99972 18.0572 7.99916L18.0478 7.9142C17.9061 6.63861 17.3768 5.49154 16.5852 4.58508Z"
        fill="#020203"
      />
      <path
        d="M9.10222 17.6647C9.27315 18.6215 9.64978 19.467 10.1737 20.0701C10.6976 20.6731 11.3396 21 12 21C12.6604 21 13.3024 20.6731 13.8263 20.0701C14.3502 19.467 14.7269 18.6215 14.8978 17.6647"
        stroke="#020203"
        stroke-linecap="round"
      />
      <circle cx="18" cy="6" r="2.5" fill="#DBBB51" stroke="#DBBB51" />
    </svg>
  );
}

export function BuyerDropdown() {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.94845 0.453125H4.79512H1.05512C0.415119 0.453125 0.0951188 1.22646 0.548452 1.67979L4.00179 5.13312C4.55512 5.68646 5.45512 5.68646 6.00845 5.13312L7.32178 3.81979L9.46179 1.67979C9.90845 1.22646 9.58845 0.453125 8.94845 0.453125Z"
        fill="#020203"
      />
    </svg>
  );
}

export function TwitterNewIcon() {
  return (
    <svg
      width="17"
      height="14"
      viewBox="0 0 17 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3419 2.041C15.7483 2.30405 15.1105 2.48178 14.4401 2.56212C15.1319 2.1482 15.6494 1.49675 15.8961 0.729308C15.2462 1.11534 14.5349 1.38707 13.7932 1.53267C13.2943 1.00008 12.6337 0.64707 11.9137 0.528448C11.1937 0.409826 10.4546 0.532228 9.81134 0.876653C9.16803 1.22108 8.65644 1.76825 8.35598 2.43323C8.05552 3.0982 7.983 3.84377 8.14969 4.55418C6.8328 4.48806 5.54453 4.14578 4.36849 3.54955C3.19245 2.95332 2.15491 2.11647 1.32322 1.09331C1.03884 1.58386 0.875325 2.15262 0.875325 2.75834C0.875008 3.30363 1.00929 3.84057 1.26626 4.32151C1.52323 4.80246 1.89493 5.21254 2.3484 5.51538C1.8225 5.49864 1.3082 5.35654 0.84831 5.10089V5.14355C0.848257 5.90834 1.1128 6.6496 1.59706 7.24154C2.08132 7.83349 2.75546 8.23966 3.5051 8.39114C3.01724 8.52317 2.50576 8.54262 2.00928 8.44801C2.22078 9.10607 2.63277 9.68152 3.18757 10.0938C3.74237 10.5061 4.41221 10.7345 5.1033 10.7472C3.93013 11.6682 2.48127 12.1677 0.989787 12.1655C0.725587 12.1656 0.461611 12.1502 0.199219 12.1193C1.71315 13.0927 3.47549 13.6093 5.27535 13.6073C11.3681 13.6073 14.6989 8.56105 14.6989 4.18449C14.6989 4.0423 14.6953 3.89869 14.6889 3.7565C15.3368 3.28797 15.8961 2.70779 16.3405 2.04313L16.3419 2.041Z"
        fill="#FDFDFF"
      />
    </svg>
  );
}

export function FacebookNewIcon() {
  return (
    <svg
      width="9"
      height="14"
      viewBox="0 0 9 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.2735 1.01983C8.2735 0.925554 8.23604 0.835139 8.16938 0.768475C8.10272 0.701811 8.0123 0.66436 7.91802 0.66436H6.14067C5.24568 0.619777 4.36942 0.931242 3.70336 1.5307C3.03729 2.13016 2.63557 2.96888 2.58595 3.8636V5.78315H0.808596C0.71432 5.78315 0.623904 5.8206 0.55724 5.88726C0.490576 5.95393 0.453125 6.04434 0.453125 6.13862V7.98707C0.453125 8.08135 0.490576 8.17176 0.55724 8.23843C0.623904 8.30509 0.71432 8.34254 0.808596 8.34254H2.58595V13.1059C2.58595 13.2001 2.6234 13.2906 2.69007 13.3572C2.75673 13.4239 2.84715 13.4613 2.94142 13.4613H5.07425C5.16853 13.4613 5.25895 13.4239 5.32561 13.3572C5.39227 13.2906 5.42972 13.2001 5.42972 13.1059V8.34254H7.29239C7.37144 8.34368 7.44862 8.31843 7.51171 8.27079C7.5748 8.22315 7.62021 8.15584 7.64076 8.07949L8.15264 6.23104C8.16678 6.17852 8.16868 6.12345 8.15819 6.07008C8.14771 6.0167 8.12511 5.96645 8.09214 5.92318C8.05918 5.87992 8.01672 5.84479 7.96805 5.82051C7.91937 5.79624 7.86578 5.78345 7.81138 5.78315H5.42972V3.8636C5.44741 3.68763 5.53005 3.52456 5.66151 3.40625C5.79297 3.28793 5.96381 3.22287 6.14067 3.22375H7.91802C8.0123 3.22375 8.10272 3.1863 8.16938 3.11964C8.23604 3.05298 8.2735 2.96256 8.2735 2.86828V1.01983Z"
        fill="#FDFDFF"
      />
    </svg>
  );
}

export function InstaNewIcon() {
  return (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.37767 4.84179C6.15463 4.84179 5.15653 5.83989 5.15653 7.06293C5.15653 8.28597 6.15463 9.28407 7.37767 9.28407C8.60071 9.28407 9.59881 8.28597 9.59881 7.06293C9.59881 5.83989 8.60071 4.84179 7.37767 4.84179ZM14.0394 7.06293C14.0394 6.14315 14.0478 5.2317 13.9961 4.31358C13.9445 3.24717 13.7012 2.30072 12.9214 1.52091C12.1399 0.739426 11.1951 0.497817 10.1287 0.446162C9.2089 0.394508 8.29745 0.402839 7.37934 0.402839C6.45955 0.402839 5.5481 0.394508 4.62999 0.446162C3.56357 0.497817 2.61713 0.741093 1.83731 1.52091C1.05583 2.30239 0.814223 3.24717 0.762569 4.31358C0.710914 5.23336 0.719246 6.14481 0.719246 7.06293C0.719246 7.98105 0.710914 8.89416 0.762569 9.81228C0.814223 10.8787 1.0575 11.8251 1.83731 12.605C2.6188 13.3864 3.56357 13.628 4.62999 13.6797C5.54977 13.7314 6.46122 13.723 7.37934 13.723C8.29912 13.723 9.21057 13.7314 10.1287 13.6797C11.1951 13.628 12.1415 13.3848 12.9214 12.605C13.7028 11.8235 13.9445 10.8787 13.9961 9.81228C14.0494 8.89416 14.0394 7.98271 14.0394 7.06293ZM7.37767 10.4805C5.48645 10.4805 3.96015 8.95415 3.96015 7.06293C3.96015 5.17171 5.48645 3.6454 7.37767 3.6454C9.26889 3.6454 10.7952 5.17171 10.7952 7.06293C10.7952 8.95415 9.26889 10.4805 7.37767 10.4805ZM10.9352 4.30358C10.4936 4.30358 10.137 3.947 10.137 3.50544C10.137 3.06388 10.4936 2.70729 10.9352 2.70729C11.3767 2.70729 11.7333 3.06388 11.7333 3.50544C11.7334 3.61029 11.7129 3.71414 11.6728 3.81103C11.6328 3.90793 11.574 3.99596 11.4998 4.07011C11.4257 4.14425 11.3376 4.20303 11.2408 4.2431C11.1439 4.28316 11.04 4.30371 10.9352 4.30358Z"
        fill="#FDFDFF"
      />
    </svg>
  );
}

export function AppleLogo() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" transform="translate(0 0.5)" fill="white" />
      <path
        d="M21.2798 18.924C20.932 19.7275 20.5203 20.4672 20.0433 21.1472C19.393 22.0743 18.8606 22.716 18.4503 23.0724C17.8143 23.6573 17.1329 23.9568 16.4031 23.9739C15.8792 23.9739 15.2475 23.8248 14.5121 23.5224C13.7742 23.2214 13.0962 23.0724 12.4762 23.0724C11.826 23.0724 11.1286 23.2214 10.3827 23.5224C9.63565 23.8248 9.03383 23.9824 8.5737 23.998C7.87393 24.0278 7.17643 23.7197 6.4802 23.0724C6.03583 22.6848 5.48002 22.0204 4.81417 21.0791C4.09977 20.0739 3.51244 18.9084 3.05231 17.5795C2.55953 16.1442 2.3125 14.7543 2.3125 13.4087C2.3125 11.8673 2.64556 10.5379 3.31269 9.42385C3.83698 8.529 4.53449 7.82312 5.40747 7.30493C6.28045 6.78674 7.2237 6.52267 8.23951 6.50578C8.79532 6.50578 9.5242 6.6777 10.43 7.01559C11.3332 7.35462 11.9131 7.52655 12.1674 7.52655C12.3575 7.52655 13.0018 7.32552 14.094 6.92473C15.1268 6.55305 15.9985 6.39916 16.7126 6.45978C18.6477 6.61595 20.1015 7.37876 21.0683 8.75303C19.3377 9.80163 18.4816 11.2703 18.4986 13.1544C18.5142 14.622 19.0466 15.8432 20.0929 16.8129C20.5671 17.2629 21.0967 17.6107 21.6859 17.8578C21.5581 18.2283 21.4232 18.5832 21.2798 18.924ZM16.8418 1.46013C16.8418 2.61039 16.4216 3.68439 15.5839 4.67847C14.5731 5.86023 13.3505 6.54311 12.0246 6.43536C12.0077 6.29736 11.9979 6.15213 11.9979 5.99951C11.9979 4.89526 12.4786 3.71349 13.3323 2.74724C13.7585 2.25801 14.3005 1.85122 14.9579 1.52671C15.6138 1.20705 16.2342 1.03027 16.8177 1C16.8347 1.15377 16.8418 1.30755 16.8418 1.46012V1.46013Z"
        fill="black"
      />
    </svg>
  );
}

export function GoogleLogo() {
  return (
    <svg
      width="29"
      height="25"
      viewBox="0 0 29 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" transform="translate(0 0.5)" fill="white" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M28.54 12.7605C28.54 11.945 28.4668 11.1609 28.3309 10.4082H17.5V14.8566H23.6891C23.4225 16.2941 22.6123 17.5121 21.3943 18.3275V21.213H25.1109C27.2855 19.2109 28.54 16.2627 28.54 12.7605Z"
        fill="#4285F4"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.4995 24.0005C20.6045 24.0005 23.2077 22.9708 25.1104 21.2144L21.3938 18.329C20.364 19.019 19.0467 19.4267 17.4995 19.4267C14.5042 19.4267 11.969 17.4037 11.0647 14.6855H7.22266V17.6651C9.11493 21.4235 13.004 24.0005 17.4995 24.0005Z"
        fill="#34A853"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.0652 14.6855C10.8352 13.9955 10.7045 13.2584 10.7045 12.5005C10.7045 11.7425 10.8352 11.0055 11.0652 10.3155V7.33594H7.22318C6.44432 8.88844 6 10.6448 6 12.5005C6 14.3562 6.44432 16.1125 7.22318 17.665L11.0652 14.6855Z"
        fill="#FBBC05"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.4995 5.57386C19.1879 5.57386 20.7038 6.15409 21.8956 7.29364L25.194 3.99523C23.2024 2.13955 20.5992 1 17.4995 1C13.004 1 9.11493 3.57705 7.22266 7.33545L11.0647 10.315C11.969 7.59682 14.5042 5.57386 17.4995 5.57386Z"
        fill="#EA4335"
      />
    </svg>
  );
}

export function FbIcon() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" transform="translate(0 0.5)" fill="white" />
      <path
        d="M23.5 12.5694C23.5 6.21811 18.3513 1.06939 12 1.06939C5.64872 1.06939 0.5 6.21811 0.5 12.5694C0.5 18.3094 4.70538 23.067 10.2031 23.9297V15.8936H7.2832V12.5694H10.2031V10.0358C10.2031 7.15361 11.92 5.56158 14.5468 5.56158C15.805 5.56158 17.1211 5.78619 17.1211 5.78619V8.61627H15.671C14.2424 8.61627 13.7969 9.50273 13.7969 10.4122V12.5694H16.9863L16.4765 15.8936H13.7969V23.9297C19.2946 23.067 23.5 18.3094 23.5 12.5694Z"
        fill="#4285F4"
      />
    </svg>
  );
}

export function DeleteBinIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9997 6.73046C20.9797 6.73046 20.9497 6.73046 20.9197 6.73046C15.6297 6.20046 10.3497 6.00046 5.11967 6.53046L3.07967 6.73046C2.65967 6.77046 2.28967 6.47046 2.24967 6.05046C2.20967 5.63046 2.50967 5.27046 2.91967 5.23046L4.95967 5.03046C10.2797 4.49046 15.6697 4.70046 21.0697 5.23046C21.4797 5.27046 21.7797 5.64046 21.7397 6.05046C21.7097 6.44046 21.3797 6.73046 20.9997 6.73046Z"
        fill="#F66356"
      />
      <path
        d="M8.49977 5.72C8.45977 5.72 8.41977 5.72 8.36977 5.71C7.96977 5.64 7.68977 5.25 7.75977 4.85L7.97977 3.54C8.13977 2.58 8.35977 1.25 10.6898 1.25H13.3098C15.6498 1.25 15.8698 2.63 16.0198 3.55L16.2398 4.85C16.3098 5.26 16.0298 5.65 15.6298 5.71C15.2198 5.78 14.8298 5.5 14.7698 5.1L14.5498 3.8C14.4098 2.93 14.3798 2.76 13.3198 2.76H10.6998C9.63977 2.76 9.61977 2.9 9.46977 3.79L9.23977 5.09C9.17977 5.46 8.85977 5.72 8.49977 5.72Z"
        fill="#F66356"
      />
      <path
        d="M15.2104 22.7496H8.79039C5.30039 22.7496 5.16039 20.8196 5.05039 19.2596L4.40039 9.18959C4.37039 8.77959 4.69039 8.41959 5.10039 8.38959C5.52039 8.36959 5.87039 8.67959 5.90039 9.08959L6.55039 19.1596C6.66039 20.6796 6.70039 21.2496 8.79039 21.2496H15.2104C17.3104 21.2496 17.3504 20.6796 17.4504 19.1596L18.1004 9.08959C18.1304 8.67959 18.4904 8.36959 18.9004 8.38959C19.3104 8.41959 19.6304 8.76959 19.6004 9.18959L18.9504 19.2596C18.8404 20.8196 18.7004 22.7496 15.2104 22.7496Z"
        fill="#F66356"
      />
      <path
        d="M13.6601 17.25H10.3301C9.92008 17.25 9.58008 16.91 9.58008 16.5C9.58008 16.09 9.92008 15.75 10.3301 15.75H13.6601C14.0701 15.75 14.4101 16.09 14.4101 16.5C14.4101 16.91 14.0701 17.25 13.6601 17.25Z"
        fill="#F66356"
      />
      <path
        d="M14.5 13.25H9.5C9.09 13.25 8.75 12.91 8.75 12.5C8.75 12.09 9.09 11.75 9.5 11.75H14.5C14.91 11.75 15.25 12.09 15.25 12.5C15.25 12.91 14.91 13.25 14.5 13.25Z"
        fill="#F66356"
      />
    </svg>
  );
}

export function AllHome() {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.332 8.5L14.0391 7.79289L14.7462 8.5L14.0391 9.20711L13.332 8.5ZM3.33203 9.5C2.77975 9.5 2.33203 9.05228 2.33203 8.5C2.33203 7.94772 2.77975 7.5 3.33203 7.5V9.5ZM10.0391 3.79289L14.0391 7.79289L12.6249 9.20711L8.62492 5.20711L10.0391 3.79289ZM14.0391 9.20711L10.0391 13.2071L8.62492 11.7929L12.6249 7.79289L14.0391 9.20711ZM13.332 9.5H3.33203V7.5H13.332V9.5Z"
        fill="#020203"
      />
    </svg>
  );
}

export function BackPage() {
  return (
    <svg
      width="6"
      height="12"
      viewBox="0 0 6 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.52796 1.53269C5.82216 1.24111 5.82427 0.766239 5.53269 0.472042C5.24111 0.177845 4.76624 0.175726 4.47204 0.46731L2.67731 2.2461C2.00134 2.91604 1.44886 3.46359 1.05706 3.95146C0.649627 4.45878 0.354694 4.97372 0.275908 5.59184C0.241363 5.86286 0.241363 6.13714 0.275908 6.40816C0.354694 7.02628 0.649627 7.54122 1.05706 8.04854C1.44886 8.53641 2.00133 9.08395 2.67729 9.75389L4.47204 11.5327C4.76624 11.8243 5.2411 11.8222 5.53269 11.528C5.82427 11.2338 5.82215 10.7589 5.52796 10.4673L3.76499 8.72C3.0495 8.01086 2.55869 7.52282 2.22659 7.1093C1.90399 6.7076 1.79332 6.44958 1.76387 6.21851C1.74538 6.07341 1.74538 5.92659 1.76387 5.7815C1.79332 5.55042 1.90399 5.2924 2.22659 4.89071C2.55869 4.47718 3.0495 3.98914 3.76499 3.28L5.52796 1.53269Z"
        fill="#707581"
      />
    </svg>
  );
}

export function NextPage(){
  return(
    <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.472041 1.53269C0.177844 1.24111 0.175726 0.766239 0.467309 0.472042C0.758893 0.177845 1.23376 0.175726 1.52796 0.46731L3.32269 2.2461C3.99866 2.91604 4.55114 3.46359 4.94294 3.95146C5.35037 4.45878 5.64531 4.97372 5.72409 5.59184C5.75864 5.86286 5.75864 6.13714 5.72409 6.40816C5.64531 7.02628 5.35037 7.54122 4.94294 8.04854C4.55114 8.53641 3.99867 9.08395 3.32271 9.75389L1.52796 11.5327C1.23376 11.8243 0.758895 11.8222 0.467311 11.528C0.175728 11.2338 0.177846 10.7589 0.472043 10.4673L2.23501 8.72C2.9505 8.01086 3.44131 7.52282 3.77341 7.1093C4.09601 6.7076 4.20668 6.44958 4.23613 6.21851C4.25462 6.07341 4.25462 5.92659 4.23613 5.7815C4.20668 5.55042 4.09601 5.2924 3.77341 4.89071C3.44131 4.47718 2.9505 3.98914 2.23501 3.28L0.472041 1.53269Z" fill="#707581"/>
</svg>
  )
}

export function NextestPage(){
  return(
    <svg width="29" height="24" viewBox="0 0 29 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.47204 16.4673C9.17784 16.7589 9.17573 17.2338 9.46731 17.528C9.75889 17.8222 10.2338 17.8243 10.528 17.5327L12.3227 15.7539C12.9987 15.084 13.5511 14.5364 13.9429 14.0485C14.3504 13.5412 14.6453 13.0263 14.7241 12.4082C14.7586 12.1371 14.7586 11.8629 14.7241 11.5918C14.6453 10.9737 14.3504 10.4588 13.9429 9.95146C13.5511 9.46359 12.9987 8.91605 12.3227 8.24611L10.528 6.46731C10.2338 6.17573 9.75889 6.17784 9.46731 6.47204C9.17572 6.76624 9.17784 7.24111 9.47204 7.53269L11.235 9.28C11.9505 9.98914 12.4413 10.4772 12.7734 10.8907C13.096 11.2924 13.2067 11.5504 13.2361 11.7815C13.2546 11.9266 13.2546 12.0734 13.2361 12.2185C13.2067 12.4496 13.096 12.7076 12.7734 13.1093C12.4413 13.5228 11.9505 14.0109 11.235 14.72L9.47204 16.4673Z" fill="#707581"/>
<path d="M14.472 16.4673C14.1778 16.7589 14.1757 17.2338 14.4673 17.528C14.7589 17.8222 15.2338 17.8243 15.528 17.5327L17.3227 15.7539C17.9987 15.084 18.5511 14.5364 18.9429 14.0485C19.3504 13.5412 19.6453 13.0263 19.7241 12.4082C19.7586 12.1371 19.7586 11.8629 19.7241 11.5918C19.6453 10.9737 19.3504 10.4588 18.9429 9.95146C18.5511 9.46359 17.9987 8.91605 17.3227 8.24611L15.528 6.46731C15.2338 6.17573 14.7589 6.17784 14.4673 6.47204C14.1757 6.76624 14.1778 7.24111 14.472 7.53269L16.235 9.28C16.9505 9.98914 17.4413 10.4772 17.7734 10.8907C18.096 11.2924 18.2067 11.5504 18.2361 11.7815C18.2546 11.9266 18.2546 12.0734 18.2361 12.2185C18.2067 12.4496 18.096 12.7076 17.7734 13.1093C17.4413 13.5228 16.9505 14.0109 16.235 14.72L14.472 16.4673Z" fill="#707581"/>
</svg>
  )
}

export function HiddenPagesNo(){
  return(
    <svg width="15" height="4" viewBox="0 0 15 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="7.55577" cy="1.99989" r="1.55556" transform="rotate(90 7.55577 1.99989)" fill="#707581"/>
<circle cx="13.0001" cy="1.99989" r="1.55556" transform="rotate(90 13.0001 1.99989)" fill="#707581"/>
<circle cx="2.11131" cy="1.99989" r="1.55556" transform="rotate(90 2.11131 1.99989)" fill="#707581"/>
</svg>
  )
}